export const HOAI2009 = {
  year: 2009,
  validFrom: '2009-08-18',
  correspondingDin: 2008,
  rateOptions: [
    {
      label: 'Minimum honorarium rate',
      value: 0,
    },
    {
      label: 'Quarter rate',
      value: 25,
    },
    {
      label: 'Middle rate',
      value: 50,
    },
    {
      label: 'Three quarter rate',
      value: 75,
    },
    {
      label: 'Maximum honorarium rate',
      value: 100,
    },
  ],
  data: [
    {
      label: '§ 34 Abs. 1 Gebäude',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '600'],
      disabledCostGroups: ['200', '600'],
      additionalFields: [],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25565: {
            min: 2182,
            max: 2654,
          },
          30000: {
            min: 2558,
            max: 3109,
          },
          35000: {
            min: 2991,
            max: 3629,
          },
          40000: {
            min: 3411,
            max: 4138,
          },
          45000: {
            min: 3843,
            max: 4657,
          },
          50000: {
            min: 4269,
            max: 5167,
          },
          100000: {
            min: 8531,
            max: 10206,
          },
          150000: {
            min: 12799,
            max: 15128,
          },
          200000: {
            min: 17061,
            max: 19927,
          },
          250000: {
            min: 21324,
            max: 24622,
          },
          300000: {
            min: 24732,
            max: 28581,
          },
          350000: {
            min: 27566,
            max: 32044,
          },
          400000: {
            min: 29999,
            max: 35114,
          },
          450000: {
            min: 32058,
            max: 37820,
          },
          500000: {
            min: 33738,
            max: 40137,
          },
          1000000: {
            min: 60822,
            max: 72089,
          },
          1500000: {
            min: 88184,
            max: 104284,
          },
          2000000: {
            min: 115506,
            max: 136436,
          },
          2500000: {
            min: 142830,
            max: 168598,
          },
          3000000: {
            min: 171226,
            max: 200401,
          },
          3500000: {
            min: 199766,
            max: 232158,
          },
          4000000: {
            min: 228305,
            max: 263920,
          },
          4500000: {
            min: 256840,
            max: 295678,
          },
          5000000: {
            min: 285379,
            max: 327439,
          },
          10000000: {
            min: 570757,
            max: 648805,
          },
          15000000: {
            min: 856136,
            max: 964745,
          },
          20000000: {
            min: 1141514,
            max: 1275044,
          },
          25000000: {
            min: 1426893,
            max: 1586268,
          },
          25564594: {
            min: 1459117,
            max: 1621426,
          },
        },
        II: {
          25565: {
            min: 2654,
            max: 3290,
          },
          30000: {
            min: 3109,
            max: 3847,
          },
          35000: {
            min: 3629,
            max: 4483,
          },
          40000: {
            min: 4138,
            max: 5112,
          },
          45000: {
            min: 4657,
            max: 5743,
          },
          50000: {
            min: 5167,
            max: 6358,
          },
          100000: {
            min: 10206,
            max: 12442,
          },
          150000: {
            min: 15128,
            max: 18236,
          },
          200000: {
            min: 19927,
            max: 23745,
          },
          250000: {
            min: 24622,
            max: 29018,
          },
          300000: {
            min: 28581,
            max: 33715,
          },
          350000: {
            min: 32044,
            max: 38017,
          },
          400000: {
            min: 35114,
            max: 41940,
          },
          450000: {
            min: 37820,
            max: 45498,
          },
          500000: {
            min: 40137,
            max: 48667,
          },
          1000000: {
            min: 72089,
            max: 87112,
          },
          1500000: {
            min: 104284,
            max: 125749,
          },
          2000000: {
            min: 136436,
            max: 164341,
          },
          2500000: {
            min: 168598,
            max: 202953,
          },
          3000000: {
            min: 200401,
            max: 239295,
          },
          3500000: {
            min: 232158,
            max: 275353,
          },
          4000000: {
            min: 263920,
            max: 311411,
          },
          4500000: {
            min: 295678,
            max: 347465,
          },
          5000000: {
            min: 327439,
            max: 383522,
          },
          10000000: {
            min: 648805,
            max: 752869,
          },
          15000000: {
            min: 964745,
            max: 1109559,
          },
          20000000: {
            min: 1275044,
            max: 1453088,
          },
          25000000: {
            min: 1586268,
            max: 1798766,
          },
          25564594: {
            min: 1621426,
            max: 1837835,
          },
        },
        III: {
          25565: {
            min: 3290,
            max: 4241,
          },
          30000: {
            min: 3847,
            max: 4948,
          },
          35000: {
            min: 4483,
            max: 5760,
          },
          40000: {
            min: 5112,
            max: 6565,
          },
          45000: {
            min: 5743,
            max: 7372,
          },
          50000: {
            min: 6358,
            max: 8154,
          },
          100000: {
            min: 12442,
            max: 15796,
          },
          150000: {
            min: 18236,
            max: 22900,
          },
          200000: {
            min: 23745,
            max: 29471,
          },
          250000: {
            min: 29018,
            max: 35610,
          },
          300000: {
            min: 33715,
            max: 41407,
          },
          350000: {
            min: 38017,
            max: 46970,
          },
          400000: {
            min: 41940,
            max: 52175,
          },
          450000: {
            min: 45498,
            max: 57024,
          },
          500000: {
            min: 48667,
            max: 61464,
          },
          1000000: {
            min: 87112,
            max: 109650,
          },
          1500000: {
            min: 125749,
            max: 157951,
          },
          2000000: {
            min: 164341,
            max: 206201,
          },
          2500000: {
            min: 202953,
            max: 254487,
          },
          3000000: {
            min: 239295,
            max: 297639,
          },
          3500000: {
            min: 275353,
            max: 340143,
          },
          4000000: {
            min: 311411,
            max: 382642,
          },
          4500000: {
            min: 347465,
            max: 425145,
          },
          5000000: {
            min: 383522,
            max: 467649,
          },
          10000000: {
            min: 752869,
            max: 908967,
          },
          15000000: {
            min: 1109559,
            max: 1326782,
          },
          20000000: {
            min: 1453088,
            max: 1720148,
          },
          25000000: {
            min: 1798766,
            max: 2117513,
          },
          25564594: {
            min: 1837835,
            max: 2162447,
          },
        },
        IV: {
          25565: {
            min: 4241,
            max: 4876,
          },
          30000: {
            min: 4948,
            max: 5686,
          },
          35000: {
            min: 5760,
            max: 6613,
          },
          40000: {
            min: 6565,
            max: 7538,
          },
          45000: {
            min: 7372,
            max: 8458,
          },
          50000: {
            min: 8154,
            max: 9346,
          },
          100000: {
            min: 15796,
            max: 18032,
          },
          150000: {
            min: 22900,
            max: 26008,
          },
          200000: {
            min: 29471,
            max: 33289,
          },
          250000: {
            min: 35610,
            max: 40006,
          },
          300000: {
            min: 41407,
            max: 46540,
          },
          350000: {
            min: 46970,
            max: 52944,
          },
          400000: {
            min: 52175,
            max: 59001,
          },
          450000: {
            min: 57024,
            max: 64702,
          },
          500000: {
            min: 61464,
            max: 69994,
          },
          1000000: {
            min: 109650,
            max: 124674,
          },
          1500000: {
            min: 157951,
            max: 179416,
          },
          2000000: {
            min: 206201,
            max: 234105,
          },
          2500000: {
            min: 254487,
            max: 288842,
          },
          3000000: {
            min: 297639,
            max: 336534,
          },
          3500000: {
            min: 340143,
            max: 383337,
          },
          4000000: {
            min: 382642,
            max: 430133,
          },
          4500000: {
            min: 425145,
            max: 476931,
          },
          5000000: {
            min: 467649,
            max: 523731,
          },
          10000000: {
            min: 908967,
            max: 1013031,
          },
          15000000: {
            min: 1326782,
            max: 1471595,
          },
          20000000: {
            min: 1720148,
            max: 1898192,
          },
          25000000: {
            min: 2117513,
            max: 2330011,
          },
          25564594: {
            min: 2162447,
            max: 2378856,
          },
        },
        V: {
          25565: {
            min: 4876,
            max: 5348,
          },
          30000: {
            min: 5686,
            max: 6237,
          },
          35000: {
            min: 6613,
            max: 7252,
          },
          40000: {
            min: 7538,
            max: 8264,
          },
          45000: {
            min: 8458,
            max: 9272,
          },
          50000: {
            min: 9346,
            max: 10243,
          },
          100000: {
            min: 18032,
            max: 19708,
          },
          150000: {
            min: 26008,
            max: 28337,
          },
          200000: {
            min: 33289,
            max: 36155,
          },
          250000: {
            min: 40006,
            max: 43305,
          },
          300000: {
            min: 46540,
            max: 50389,
          },
          350000: {
            min: 52944,
            max: 57421,
          },
          400000: {
            min: 59001,
            max: 64116,
          },
          450000: {
            min: 64702,
            max: 70465,
          },
          500000: {
            min: 69994,
            max: 76392,
          },
          1000000: {
            min: 124674,
            max: 135940,
          },
          1500000: {
            min: 179416,
            max: 195516,
          },
          2000000: {
            min: 234105,
            max: 255036,
          },
          2500000: {
            min: 288842,
            max: 314607,
          },
          3000000: {
            min: 336534,
            max: 365708,
          },
          3500000: {
            min: 383337,
            max: 415731,
          },
          4000000: {
            min: 430133,
            max: 465748,
          },
          4500000: {
            min: 476931,
            max: 515769,
          },
          5000000: {
            min: 523731,
            max: 565792,
          },
          10000000: {
            min: 1013031,
            max: 1091079,
          },
          15000000: {
            min: 1471595,
            max: 1580205,
          },
          20000000: {
            min: 1898192,
            max: 2031722,
          },
          25000000: {
            min: 2330011,
            max: 2489383,
          },
          25564594: {
            min: 2378856,
            max: 2541160,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Vorplanung',
          maxPercent: '7',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '11',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '6',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '25',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '10',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '4',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung –',
          maxPercent: '31',
        },
        {
          title: 'Objektbetreuung und Dokumentation',
          maxPercent: '3',
        },
      ],
    },
    {
      label: '§ 34 Abs. 1 raumbildende Ausbauten',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '600'],
      disabledCostGroups: ['200', '600'],
      additionalFields: [],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25565: {
            min: 2182,
            max: 2654,
          },
          30000: {
            min: 2558,
            max: 3109,
          },
          35000: {
            min: 2991,
            max: 3629,
          },
          40000: {
            min: 3411,
            max: 4138,
          },
          45000: {
            min: 3843,
            max: 4657,
          },
          50000: {
            min: 4269,
            max: 5167,
          },
          100000: {
            min: 8531,
            max: 10206,
          },
          150000: {
            min: 12799,
            max: 15128,
          },
          200000: {
            min: 17061,
            max: 19927,
          },
          250000: {
            min: 21324,
            max: 24622,
          },
          300000: {
            min: 24732,
            max: 28581,
          },
          350000: {
            min: 27566,
            max: 32044,
          },
          400000: {
            min: 29999,
            max: 35114,
          },
          450000: {
            min: 32058,
            max: 37820,
          },
          500000: {
            min: 33738,
            max: 40137,
          },
          1000000: {
            min: 60822,
            max: 72089,
          },
          1500000: {
            min: 88184,
            max: 104284,
          },
          2000000: {
            min: 115506,
            max: 136436,
          },
          2500000: {
            min: 142830,
            max: 168598,
          },
          3000000: {
            min: 171226,
            max: 200401,
          },
          3500000: {
            min: 199766,
            max: 232158,
          },
          4000000: {
            min: 228305,
            max: 263920,
          },
          4500000: {
            min: 256840,
            max: 295678,
          },
          5000000: {
            min: 285379,
            max: 327439,
          },
          10000000: {
            min: 570757,
            max: 648805,
          },
          15000000: {
            min: 856136,
            max: 964745,
          },
          20000000: {
            min: 1141514,
            max: 1275044,
          },
          25000000: {
            min: 1426893,
            max: 1586268,
          },
          25564594: {
            min: 1459117,
            max: 1621426,
          },
        },
        II: {
          25565: {
            min: 2654,
            max: 3290,
          },
          30000: {
            min: 3109,
            max: 3847,
          },
          35000: {
            min: 3629,
            max: 4483,
          },
          40000: {
            min: 4138,
            max: 5112,
          },
          45000: {
            min: 4657,
            max: 5743,
          },
          50000: {
            min: 5167,
            max: 6358,
          },
          100000: {
            min: 10206,
            max: 12442,
          },
          150000: {
            min: 15128,
            max: 18236,
          },
          200000: {
            min: 19927,
            max: 23745,
          },
          250000: {
            min: 24622,
            max: 29018,
          },
          300000: {
            min: 28581,
            max: 33715,
          },
          350000: {
            min: 32044,
            max: 38017,
          },
          400000: {
            min: 35114,
            max: 41940,
          },
          450000: {
            min: 37820,
            max: 45498,
          },
          500000: {
            min: 40137,
            max: 48667,
          },
          1000000: {
            min: 72089,
            max: 87112,
          },
          1500000: {
            min: 104284,
            max: 125749,
          },
          2000000: {
            min: 136436,
            max: 164341,
          },
          2500000: {
            min: 168598,
            max: 202953,
          },
          3000000: {
            min: 200401,
            max: 239295,
          },
          3500000: {
            min: 232158,
            max: 275353,
          },
          4000000: {
            min: 263920,
            max: 311411,
          },
          4500000: {
            min: 295678,
            max: 347465,
          },
          5000000: {
            min: 327439,
            max: 383522,
          },
          10000000: {
            min: 648805,
            max: 752869,
          },
          15000000: {
            min: 964745,
            max: 1109559,
          },
          20000000: {
            min: 1275044,
            max: 1453088,
          },
          25000000: {
            min: 1586268,
            max: 1798766,
          },
          25564594: {
            min: 1621426,
            max: 1837835,
          },
        },
        III: {
          25565: {
            min: 3290,
            max: 4241,
          },
          30000: {
            min: 3847,
            max: 4948,
          },
          35000: {
            min: 4483,
            max: 5760,
          },
          40000: {
            min: 5112,
            max: 6565,
          },
          45000: {
            min: 5743,
            max: 7372,
          },
          50000: {
            min: 6358,
            max: 8154,
          },
          100000: {
            min: 12442,
            max: 15796,
          },
          150000: {
            min: 18236,
            max: 22900,
          },
          200000: {
            min: 23745,
            max: 29471,
          },
          250000: {
            min: 29018,
            max: 35610,
          },
          300000: {
            min: 33715,
            max: 41407,
          },
          350000: {
            min: 38017,
            max: 46970,
          },
          400000: {
            min: 41940,
            max: 52175,
          },
          450000: {
            min: 45498,
            max: 57024,
          },
          500000: {
            min: 48667,
            max: 61464,
          },
          1000000: {
            min: 87112,
            max: 109650,
          },
          1500000: {
            min: 125749,
            max: 157951,
          },
          2000000: {
            min: 164341,
            max: 206201,
          },
          2500000: {
            min: 202953,
            max: 254487,
          },
          3000000: {
            min: 239295,
            max: 297639,
          },
          3500000: {
            min: 275353,
            max: 340143,
          },
          4000000: {
            min: 311411,
            max: 382642,
          },
          4500000: {
            min: 347465,
            max: 425145,
          },
          5000000: {
            min: 383522,
            max: 467649,
          },
          10000000: {
            min: 752869,
            max: 908967,
          },
          15000000: {
            min: 1109559,
            max: 1326782,
          },
          20000000: {
            min: 1453088,
            max: 1720148,
          },
          25000000: {
            min: 1798766,
            max: 2117513,
          },
          25564594: {
            min: 1837835,
            max: 2162447,
          },
        },
        IV: {
          25565: {
            min: 4241,
            max: 4876,
          },
          30000: {
            min: 4948,
            max: 5686,
          },
          35000: {
            min: 5760,
            max: 6613,
          },
          40000: {
            min: 6565,
            max: 7538,
          },
          45000: {
            min: 7372,
            max: 8458,
          },
          50000: {
            min: 8154,
            max: 9346,
          },
          100000: {
            min: 15796,
            max: 18032,
          },
          150000: {
            min: 22900,
            max: 26008,
          },
          200000: {
            min: 29471,
            max: 33289,
          },
          250000: {
            min: 35610,
            max: 40006,
          },
          300000: {
            min: 41407,
            max: 46540,
          },
          350000: {
            min: 46970,
            max: 52944,
          },
          400000: {
            min: 52175,
            max: 59001,
          },
          450000: {
            min: 57024,
            max: 64702,
          },
          500000: {
            min: 61464,
            max: 69994,
          },
          1000000: {
            min: 109650,
            max: 124674,
          },
          1500000: {
            min: 157951,
            max: 179416,
          },
          2000000: {
            min: 206201,
            max: 234105,
          },
          2500000: {
            min: 254487,
            max: 288842,
          },
          3000000: {
            min: 297639,
            max: 336534,
          },
          3500000: {
            min: 340143,
            max: 383337,
          },
          4000000: {
            min: 382642,
            max: 430133,
          },
          4500000: {
            min: 425145,
            max: 476931,
          },
          5000000: {
            min: 467649,
            max: 523731,
          },
          10000000: {
            min: 908967,
            max: 1013031,
          },
          15000000: {
            min: 1326782,
            max: 1471595,
          },
          20000000: {
            min: 1720148,
            max: 1898192,
          },
          25000000: {
            min: 2117513,
            max: 2330011,
          },
          25564594: {
            min: 2162447,
            max: 2378856,
          },
        },
        V: {
          25565: {
            min: 4876,
            max: 5348,
          },
          30000: {
            min: 5686,
            max: 6237,
          },
          35000: {
            min: 6613,
            max: 7252,
          },
          40000: {
            min: 7538,
            max: 8264,
          },
          45000: {
            min: 8458,
            max: 9272,
          },
          50000: {
            min: 9346,
            max: 10243,
          },
          100000: {
            min: 18032,
            max: 19708,
          },
          150000: {
            min: 26008,
            max: 28337,
          },
          200000: {
            min: 33289,
            max: 36155,
          },
          250000: {
            min: 40006,
            max: 43305,
          },
          300000: {
            min: 46540,
            max: 50389,
          },
          350000: {
            min: 52944,
            max: 57421,
          },
          400000: {
            min: 59001,
            max: 64116,
          },
          450000: {
            min: 64702,
            max: 70465,
          },
          500000: {
            min: 69994,
            max: 76392,
          },
          1000000: {
            min: 124674,
            max: 135940,
          },
          1500000: {
            min: 179416,
            max: 195516,
          },
          2000000: {
            min: 234105,
            max: 255036,
          },
          2500000: {
            min: 288842,
            max: 314607,
          },
          3000000: {
            min: 336534,
            max: 365708,
          },
          3500000: {
            min: 383337,
            max: 415731,
          },
          4000000: {
            min: 430133,
            max: 465748,
          },
          4500000: {
            min: 476931,
            max: 515769,
          },
          5000000: {
            min: 523731,
            max: 565792,
          },
          10000000: {
            min: 1013031,
            max: 1091079,
          },
          15000000: {
            min: 1471595,
            max: 1580205,
          },
          20000000: {
            min: 1898192,
            max: 2031722,
          },
          25000000: {
            min: 2330011,
            max: 2489383,
          },
          25564594: {
            min: 2378856,
            max: 2541160,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Vorplanung',
          maxPercent: '7',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '14',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '2',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '30',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '7',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '3',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung –',
          maxPercent: '31',
        },
        {
          title: 'Objektbetreuung und Dokumentation',
          maxPercent: '3',
        },
      ],
    },
    {
      label: '§ 20 Abs. 1 Flächennutzungsplan',
      unitLabel: 'Verrechnungseinheiten',
      unit: 'VE',
      honorariumZone: {
        I: {
          5000: {
            min: 1041,
            max: 1169,
          },
          10000: {
            min: 2087,
            max: 2345,
          },
          20000: {
            min: 3335,
            max: 3751,
          },
          40000: {
            min: 5838,
            max: 6569,
          },
          60000: {
            min: 7924,
            max: 8914,
          },
          80000: {
            min: 9786,
            max: 11012,
          },
          100000: {
            min: 11389,
            max: 12812,
          },
          150000: {
            min: 15005,
            max: 16884,
          },
          200000: {
            min: 18065,
            max: 20326,
          },
          250000: {
            min: 20843,
            max: 23448,
          },
          300000: {
            min: 23762,
            max: 26732,
          },
          350000: {
            min: 26749,
            max: 30095,
          },
          400000: {
            min: 28903,
            max: 32514,
          },
          450000: {
            min: 30635,
            max: 34465,
          },
          500000: {
            min: 32648,
            max: 36731,
          },
          600000: {
            min: 35849,
            max: 40332,
          },
          700000: {
            min: 37936,
            max: 42677,
          },
          800000: {
            min: 40022,
            max: 45022,
          },
          900000: {
            min: 41264,
            max: 46422,
          },
          1000000: {
            min: 43076,
            max: 48458,
          },
          1500000: {
            min: 47935,
            max: 53925,
          },
          2000000: {
            min: 50021,
            max: 56276,
          },
          3000000: {
            min: 54189,
            max: 60961,
          },
        },
        II: {
          5000: {
            min: 1169,
            max: 1305,
          },
          10000: {
            min: 2345,
            max: 2604,
          },
          20000: {
            min: 3751,
            max: 4168,
          },
          40000: {
            min: 6569,
            max: 7301,
          },
          60000: {
            min: 8914,
            max: 9904,
          },
          80000: {
            min: 11012,
            max: 12233,
          },
          100000: {
            min: 12812,
            max: 14241,
          },
          150000: {
            min: 16884,
            max: 18757,
          },
          200000: {
            min: 20326,
            max: 22581,
          },
          250000: {
            min: 23448,
            max: 26057,
          },
          300000: {
            min: 26732,
            max: 29701,
          },
          350000: {
            min: 30095,
            max: 33436,
          },
          400000: {
            min: 32514,
            max: 36124,
          },
          450000: {
            min: 34465,
            max: 38295,
          },
          500000: {
            min: 36731,
            max: 40814,
          },
          600000: {
            min: 40332,
            max: 44814,
          },
          700000: {
            min: 42677,
            max: 47418,
          },
          800000: {
            min: 45022,
            max: 50021,
          },
          900000: {
            min: 46422,
            max: 51586,
          },
          1000000: {
            min: 48458,
            max: 53846,
          },
          1500000: {
            min: 53925,
            max: 59920,
          },
          2000000: {
            min: 56276,
            max: 62530,
          },
          3000000: {
            min: 60961,
            max: 67738,
          },
        },
        III: {
          5000: {
            min: 1305,
            max: 1434,
          },
          10000: {
            min: 2604,
            max: 2869,
          },
          20000: {
            min: 4168,
            max: 4589,
          },
          40000: {
            min: 7301,
            max: 8026,
          },
          60000: {
            min: 9904,
            max: 10889,
          },
          80000: {
            min: 12233,
            max: 13459,
          },
          100000: {
            min: 14241,
            max: 15663,
          },
          150000: {
            min: 18757,
            max: 20635,
          },
          200000: {
            min: 22581,
            max: 24842,
          },
          250000: {
            min: 26057,
            max: 28661,
          },
          300000: {
            min: 29701,
            max: 32671,
          },
          350000: {
            min: 33436,
            max: 36782,
          },
          400000: {
            min: 36124,
            max: 39741,
          },
          450000: {
            min: 38295,
            max: 42131,
          },
          500000: {
            min: 40814,
            max: 44892,
          },
          600000: {
            min: 44814,
            max: 49291,
          },
          700000: {
            min: 47418,
            max: 52164,
          },
          800000: {
            min: 50021,
            max: 55028,
          },
          900000: {
            min: 51586,
            max: 56742,
          },
          1000000: {
            min: 53846,
            max: 59228,
          },
          1500000: {
            min: 59920,
            max: 65910,
          },
          2000000: {
            min: 62530,
            max: 68779,
          },
          3000000: {
            min: 67738,
            max: 74510,
          },
        },
        IV: {
          5000: {
            min: 1434,
            max: 1570,
          },
          10000: {
            min: 2869,
            max: 3127,
          },
          20000: {
            min: 4589,
            max: 5005,
          },
          40000: {
            min: 8026,
            max: 8757,
          },
          60000: {
            min: 10889,
            max: 11878,
          },
          80000: {
            min: 13459,
            max: 14680,
          },
          100000: {
            min: 15663,
            max: 17092,
          },
          150000: {
            min: 20635,
            max: 22508,
          },
          200000: {
            min: 24842,
            max: 27097,
          },
          250000: {
            min: 28661,
            max: 31271,
          },
          300000: {
            min: 32671,
            max: 35641,
          },
          350000: {
            min: 36782,
            max: 40124,
          },
          400000: {
            min: 39741,
            max: 43351,
          },
          450000: {
            min: 42131,
            max: 45961,
          },
          500000: {
            min: 44892,
            max: 48975,
          },
          600000: {
            min: 49291,
            max: 53774,
          },
          700000: {
            min: 52164,
            max: 56906,
          },
          800000: {
            min: 55028,
            max: 60027,
          },
          900000: {
            min: 56742,
            max: 61906,
          },
          1000000: {
            min: 59228,
            max: 64616,
          },
          1500000: {
            min: 65910,
            max: 71906,
          },
          2000000: {
            min: 68779,
            max: 75032,
          },
          3000000: {
            min: 74510,
            max: 81287,
          },
        },
        V: {
          5000: {
            min: 1570,
            max: 1698,
          },
          10000: {
            min: 3127,
            max: 3386,
          },
          20000: {
            min: 5005,
            max: 5422,
          },
          40000: {
            min: 8757,
            max: 9488,
          },
          60000: {
            min: 11878,
            max: 12868,
          },
          80000: {
            min: 14680,
            max: 15905,
          },
          100000: {
            min: 17092,
            max: 18515,
          },
          150000: {
            min: 22508,
            max: 24387,
          },
          200000: {
            min: 27097,
            max: 29358,
          },
          250000: {
            min: 31271,
            max: 33875,
          },
          300000: {
            min: 35641,
            max: 38610,
          },
          350000: {
            min: 40124,
            max: 43470,
          },
          400000: {
            min: 43351,
            max: 46962,
          },
          450000: {
            min: 45961,
            max: 49792,
          },
          500000: {
            min: 48975,
            max: 53059,
          },
          600000: {
            min: 53774,
            max: 58256,
          },
          700000: {
            min: 56906,
            max: 61647,
          },
          800000: {
            min: 60027,
            max: 65028,
          },
          900000: {
            min: 61906,
            max: 67063,
          },
          1000000: {
            min: 64616,
            max: 69999,
          },
          1500000: {
            min: 71906,
            max: 77895,
          },
          2000000: {
            min: 75032,
            max: 81287,
          },
          3000000: {
            min: 81287,
            max: 88058,
          },
        },
      },
      phases: [
        {
          title:
            'Klären der Aufgabenstellung und Ermitteln des Leistungsumfangs',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsvorgaben',
          maxPercent: '20',
        },
        {
          title: 'Vorentwurf',
          maxPercent: '40',
        },
        {
          title: 'Entwurf',
          maxPercent: '30',
        },
        {
          title: 'Genehmigungsfähige Planfassung',
          maxPercent: '7',
        },
      ],
    },
    {
      label: '§ 21 Abs. 1 Bebauungsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          0.5: {
            min: 472,
            max: 1592,
          },
          1: {
            min: 954,
            max: 2907,
          },
          2: {
            min: 1895,
            max: 5068,
          },
          3: {
            min: 2840,
            max: 7036,
          },
          4: {
            min: 3791,
            max: 8813,
          },
          5: {
            min: 4736,
            max: 10579,
          },
          6: {
            min: 5686,
            max: 12120,
          },
          7: {
            min: 6524,
            max: 13464,
          },
          8: {
            min: 7149,
            max: 14645,
          },
          9: {
            min: 7778,
            max: 15787,
          },
          10: {
            min: 8403,
            max: 16918,
          },
          11: {
            min: 9021,
            max: 18009,
          },
          12: {
            min: 9651,
            max: 19021,
          },
          13: {
            min: 10281,
            max: 20033,
          },
          14: {
            min: 10832,
            max: 21108,
          },
          15: {
            min: 11350,
            max: 22210,
          },
          16: {
            min: 11872,
            max: 23323,
          },
          17: {
            min: 12396,
            max: 24432,
          },
          18: {
            min: 12918,
            max: 25540,
          },
          19: {
            min: 13442,
            max: 26648,
          },
          20: {
            min: 13959,
            max: 27755,
          },
          21: {
            min: 14483,
            max: 28807,
          },
          22: {
            min: 15005,
            max: 29871,
          },
          23: {
            min: 15511,
            max: 30917,
          },
          24: {
            min: 16035,
            max: 31974,
          },
          25: {
            min: 16569,
            max: 33042,
          },
          30: {
            min: 18796,
            max: 38133,
          },
          35: {
            min: 20821,
            max: 43031,
          },
          40: {
            min: 22862,
            max: 47777,
          },
          45: {
            min: 24899,
            max: 52271,
          },
          50: {
            min: 26940,
            max: 56602,
          },
          60: {
            min: 30124,
            max: 64099,
          },
          70: {
            min: 32896,
            max: 70634,
          },
          80: {
            min: 35618,
            max: 77131,
          },
          90: {
            min: 38200,
            max: 83648,
          },
          100: {
            min: 40736,
            max: 90454,
          },
        },
        II: {
          0.5: {
            min: 1592,
            max: 3516,
          },
          1: {
            min: 2907,
            max: 6266,
          },
          2: {
            min: 5068,
            max: 10512,
          },
          3: {
            min: 7036,
            max: 14230,
          },
          4: {
            min: 8813,
            max: 17419,
          },
          5: {
            min: 10579,
            max: 20602,
          },
          6: {
            min: 12120,
            max: 23155,
          },
          7: {
            min: 13464,
            max: 25359,
          },
          8: {
            min: 14645,
            max: 27502,
          },
          9: {
            min: 15787,
            max: 29516,
          },
          10: {
            min: 16918,
            max: 31518,
          },
          11: {
            min: 18009,
            max: 33414,
          },
          12: {
            min: 19021,
            max: 35083,
          },
          13: {
            min: 20033,
            max: 36754,
          },
          14: {
            min: 21108,
            max: 38722,
          },
          15: {
            min: 22210,
            max: 40832,
          },
          16: {
            min: 23323,
            max: 42952,
          },
          17: {
            min: 24432,
            max: 45062,
          },
          18: {
            min: 25540,
            max: 47176,
          },
          19: {
            min: 26648,
            max: 49286,
          },
          20: {
            min: 27755,
            max: 51400,
          },
          21: {
            min: 28807,
            max: 53368,
          },
          22: {
            min: 29871,
            max: 55353,
          },
          23: {
            min: 30917,
            max: 57322,
          },
          24: {
            min: 31974,
            max: 59302,
          },
          25: {
            min: 33042,
            max: 61287,
          },
          30: {
            min: 38133,
            max: 71287,
          },
          35: {
            min: 43031,
            max: 81106,
          },
          40: {
            min: 47777,
            max: 90494,
          },
          45: {
            min: 52271,
            max: 99195,
          },
          50: {
            min: 56602,
            max: 107450,
          },
          60: {
            min: 64099,
            max: 122343,
          },
          70: {
            min: 70634,
            max: 135324,
          },
          80: {
            min: 77131,
            max: 148288,
          },
          90: {
            min: 83648,
            max: 161561,
          },
          100: {
            min: 90454,
            max: 175689,
          },
        },
        III: {
          0.5: {
            min: 3516,
            max: 5438,
          },
          1: {
            min: 6266,
            max: 9628,
          },
          2: {
            min: 10512,
            max: 15950,
          },
          3: {
            min: 14230,
            max: 21428,
          },
          4: {
            min: 17419,
            max: 26023,
          },
          5: {
            min: 20602,
            max: 30624,
          },
          6: {
            min: 23155,
            max: 34189,
          },
          7: {
            min: 25359,
            max: 37260,
          },
          8: {
            min: 27502,
            max: 40359,
          },
          9: {
            min: 29516,
            max: 43239,
          },
          10: {
            min: 31518,
            max: 46124,
          },
          11: {
            min: 33414,
            max: 48818,
          },
          12: {
            min: 35083,
            max: 51152,
          },
          13: {
            min: 36754,
            max: 53481,
          },
          14: {
            min: 38722,
            max: 56338,
          },
          15: {
            min: 40832,
            max: 59459,
          },
          16: {
            min: 42952,
            max: 62575,
          },
          17: {
            min: 45062,
            max: 65685,
          },
          18: {
            min: 47176,
            max: 68813,
          },
          19: {
            min: 49286,
            max: 71928,
          },
          20: {
            min: 51400,
            max: 75044,
          },
          21: {
            min: 53368,
            max: 77935,
          },
          22: {
            min: 55353,
            max: 80831,
          },
          23: {
            min: 57322,
            max: 83733,
          },
          24: {
            min: 59302,
            max: 86624,
          },
          25: {
            min: 61287,
            max: 89526,
          },
          30: {
            min: 71287,
            max: 104436,
          },
          35: {
            min: 81106,
            max: 119188,
          },
          40: {
            min: 90494,
            max: 133216,
          },
          45: {
            min: 99195,
            max: 146112,
          },
          50: {
            min: 107450,
            max: 158293,
          },
          60: {
            min: 122343,
            max: 180583,
          },
          70: {
            min: 135324,
            max: 200014,
          },
          80: {
            min: 148288,
            max: 219446,
          },
          90: {
            min: 161561,
            max: 239468,
          },
          100: {
            min: 175689,
            max: 260924,
          },
        },
        IV: {
          0.5: {
            min: 5438,
            max: 7362,
          },
          1: {
            min: 9628,
            max: 12987,
          },
          2: {
            min: 15950,
            max: 21395,
          },
          3: {
            min: 21428,
            max: 28622,
          },
          4: {
            min: 26023,
            max: 34628,
          },
          5: {
            min: 30624,
            max: 40646,
          },
          6: {
            min: 34189,
            max: 45224,
          },
          7: {
            min: 37260,
            max: 49156,
          },
          8: {
            min: 40359,
            max: 53216,
          },
          9: {
            min: 43239,
            max: 56968,
          },
          10: {
            min: 46124,
            max: 60724,
          },
          11: {
            min: 48818,
            max: 64222,
          },
          12: {
            min: 51152,
            max: 67214,
          },
          13: {
            min: 53481,
            max: 70201,
          },
          14: {
            min: 56338,
            max: 73953,
          },
          15: {
            min: 59459,
            max: 78081,
          },
          16: {
            min: 62575,
            max: 82203,
          },
          17: {
            min: 65685,
            max: 86315,
          },
          18: {
            min: 68813,
            max: 90449,
          },
          19: {
            min: 71928,
            max: 94566,
          },
          20: {
            min: 75044,
            max: 98688,
          },
          21: {
            min: 77935,
            max: 102496,
          },
          22: {
            min: 80831,
            max: 106315,
          },
          23: {
            min: 83733,
            max: 110139,
          },
          24: {
            min: 86624,
            max: 113952,
          },
          25: {
            min: 89526,
            max: 117772,
          },
          30: {
            min: 104436,
            max: 137590,
          },
          35: {
            min: 119188,
            max: 157264,
          },
          40: {
            min: 133216,
            max: 175931,
          },
          45: {
            min: 146112,
            max: 193035,
          },
          50: {
            min: 158293,
            max: 209142,
          },
          60: {
            min: 180583,
            max: 238827,
          },
          70: {
            min: 200014,
            max: 264704,
          },
          80: {
            min: 219446,
            max: 290604,
          },
          90: {
            min: 239468,
            max: 317380,
          },
          100: {
            min: 260924,
            max: 346159,
          },
        },
        V: {
          0.5: {
            min: 7362,
            max: 8481,
          },
          1: {
            min: 12987,
            max: 14944,
          },
          2: {
            min: 21395,
            max: 24566,
          },
          3: {
            min: 28622,
            max: 32817,
          },
          4: {
            min: 34628,
            max: 39651,
          },
          5: {
            min: 40646,
            max: 46489,
          },
          6: {
            min: 45224,
            max: 51658,
          },
          7: {
            min: 49156,
            max: 56096,
          },
          8: {
            min: 53216,
            max: 60713,
          },
          9: {
            min: 56968,
            max: 64977,
          },
          10: {
            min: 60724,
            max: 69240,
          },
          11: {
            min: 64222,
            max: 73211,
          },
          12: {
            min: 67214,
            max: 76585,
          },
          13: {
            min: 70201,
            max: 79954,
          },
          14: {
            min: 73953,
            max: 84228,
          },
          15: {
            min: 78081,
            max: 88942,
          },
          16: {
            min: 82203,
            max: 93654,
          },
          17: {
            min: 86315,
            max: 98351,
          },
          18: {
            min: 90449,
            max: 103069,
          },
          19: {
            min: 94566,
            max: 107771,
          },
          20: {
            min: 98688,
            max: 112484,
          },
          21: {
            min: 102496,
            max: 116820,
          },
          22: {
            min: 106315,
            max: 121179,
          },
          23: {
            min: 110139,
            max: 125544,
          },
          24: {
            min: 113952,
            max: 129891,
          },
          25: {
            min: 117772,
            max: 134244,
          },
          30: {
            min: 137590,
            max: 156927,
          },
          35: {
            min: 157264,
            max: 179474,
          },
          40: {
            min: 175931,
            max: 200846,
          },
          45: {
            min: 193035,
            max: 220407,
          },
          50: {
            min: 209142,
            max: 238805,
          },
          60: {
            min: 238827,
            max: 272802,
          },
          70: {
            min: 264704,
            max: 302442,
          },
          80: {
            min: 290604,
            max: 332115,
          },
          90: {
            min: 317380,
            max: 362830,
          },
          100: {
            min: 346159,
            max: 395877,
          },
        },
      },
      phases: [
        {
          title:
            'Klären der Aufgabenstellung und Ermitteln des Leistungsumfangs',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsvorgaben',
          maxPercent: '20',
        },
        {
          title: 'Vorentwurf',
          maxPercent: '40',
        },
        {
          title: 'Entwurf',
          maxPercent: '30',
        },
        {
          title: 'Genehmigungsfähige Planfassung',
          maxPercent: '7',
        },
      ],
    },
    {
      label: '§ 28 Abs. 1 Landschaftsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          1000: {
            min: 12632,
            max: 15157,
          },
          1300: {
            min: 15321,
            max: 18385,
          },
          1600: {
            min: 18257,
            max: 21907,
          },
          1900: {
            min: 20765,
            max: 24921,
          },
          2200: {
            min: 23104,
            max: 27728,
          },
          2500: {
            min: 25264,
            max: 30315,
          },
          3000: {
            min: 28593,
            max: 34313,
          },
          3500: {
            min: 31782,
            max: 38138,
          },
          4000: {
            min: 34836,
            max: 41804,
          },
          4500: {
            min: 37761,
            max: 45315,
          },
          5000: {
            min: 40550,
            max: 48661,
          },
          5500: {
            min: 43194,
            max: 51833,
          },
          6000: {
            min: 45714,
            max: 54858,
          },
          6500: {
            min: 48099,
            max: 57721,
          },
          7000: {
            min: 50354,
            max: 60421,
          },
          7500: {
            min: 52507,
            max: 63008,
          },
          8000: {
            min: 54572,
            max: 65489,
          },
          8500: {
            min: 56551,
            max: 67861,
          },
          9000: {
            min: 58441,
            max: 70128,
          },
          9500: {
            min: 60235,
            max: 72282,
          },
          10000: {
            min: 61945,
            max: 74335,
          },
          11000: {
            min: 65179,
            max: 78216,
          },
          12000: {
            min: 68334,
            max: 81995,
          },
          13000: {
            min: 71382,
            max: 85663,
          },
          14000: {
            min: 74352,
            max: 89222,
          },
          15000: {
            min: 77226,
            max: 92671,
          },
        },
        II: {
          1000: {
            min: 15157,
            max: 17688,
          },
          1300: {
            min: 18385,
            max: 21451,
          },
          1600: {
            min: 21907,
            max: 25551,
          },
          1900: {
            min: 24921,
            max: 29072,
          },
          2200: {
            min: 27728,
            max: 32344,
          },
          2500: {
            min: 30315,
            max: 35371,
          },
          3000: {
            min: 34313,
            max: 40028,
          },
          3500: {
            min: 38138,
            max: 44493,
          },
          4000: {
            min: 41804,
            max: 48773,
          },
          4500: {
            min: 45315,
            max: 52862,
          },
          5000: {
            min: 48661,
            max: 56766,
          },
          5500: {
            min: 51833,
            max: 60471,
          },
          6000: {
            min: 54858,
            max: 63998,
          },
          6500: {
            min: 57721,
            max: 67339,
          },
          7000: {
            min: 60421,
            max: 70488,
          },
          7500: {
            min: 63008,
            max: 73509,
          },
          8000: {
            min: 65489,
            max: 76399,
          },
          8500: {
            min: 67861,
            max: 79173,
          },
          9000: {
            min: 70128,
            max: 81810,
          },
          9500: {
            min: 72282,
            max: 84329,
          },
          10000: {
            min: 74335,
            max: 86720,
          },
          11000: {
            min: 78216,
            max: 91253,
          },
          12000: {
            min: 81995,
            max: 95663,
          },
          13000: {
            min: 85663,
            max: 99936,
          },
          14000: {
            min: 89222,
            max: 104093,
          },
          15000: {
            min: 92671,
            max: 108120,
          },
        },
        III: {
          1000: {
            min: 17688,
            max: 20214,
          },
          1300: {
            min: 21451,
            max: 24516,
          },
          1600: {
            min: 25551,
            max: 29201,
          },
          1900: {
            min: 29072,
            max: 33228,
          },
          2200: {
            min: 32344,
            max: 36968,
          },
          2500: {
            min: 35371,
            max: 40422,
          },
          3000: {
            min: 40028,
            max: 45747,
          },
          3500: {
            min: 44493,
            max: 50849,
          },
          4000: {
            min: 48773,
            max: 55741,
          },
          4500: {
            min: 52862,
            max: 60415,
          },
          5000: {
            min: 56766,
            max: 64876,
          },
          5500: {
            min: 60471,
            max: 69111,
          },
          6000: {
            min: 63998,
            max: 73143,
          },
          6500: {
            min: 67339,
            max: 76962,
          },
          7000: {
            min: 70488,
            max: 80555,
          },
          7500: {
            min: 73509,
            max: 84009,
          },
          8000: {
            min: 76399,
            max: 87316,
          },
          8500: {
            min: 79173,
            max: 90483,
          },
          9000: {
            min: 81810,
            max: 93497,
          },
          9500: {
            min: 84329,
            max: 96377,
          },
          10000: {
            min: 86720,
            max: 99110,
          },
          11000: {
            min: 91253,
            max: 104290,
          },
          12000: {
            min: 95663,
            max: 109324,
          },
          13000: {
            min: 99936,
            max: 114216,
          },
          14000: {
            min: 104093,
            max: 118963,
          },
          15000: {
            min: 108120,
            max: 123564,
          },
        },
      },
      phases: [
        {
          title:
            'Klären der Aufgabenstellung und Ermitteln des Leistungsumfangs',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Planfassung – Vorentwurf -',
          maxPercent: '50',
        },
        {
          title: 'Entwurf',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 29 Abs. 1 Grünordnungsplan',
      unitLabel: 'Verrechnungseinheiten',
      unit: 'VE',
      honorariumZone: {
        Normalstufe: {
          1500: {
            min: 1895,
            max: 2368,
          },
          5000: {
            min: 6316,
            max: 7897,
          },
          10000: {
            min: 10483,
            max: 13110,
          },
          20000: {
            min: 17435,
            max: 21794,
          },
          40000: {
            min: 28295,
            max: 35371,
          },
          60000: {
            min: 35618,
            max: 44527,
          },
          80000: {
            min: 42440,
            max: 53053,
          },
          100000: {
            min: 48003,
            max: 60005,
          },
          150000: {
            min: 66321,
            max: 82900,
          },
          200000: {
            min: 83368,
            max: 104211,
          },
          250000: {
            min: 101056,
            max: 126320,
          },
          300000: {
            min: 117473,
            max: 146848,
          },
          350000: {
            min: 132630,
            max: 165791,
          },
          400000: {
            min: 146528,
            max: 183163,
          },
          450000: {
            min: 159159,
            max: 198950,
          },
          500000: {
            min: 170526,
            max: 213164,
          },
          600000: {
            min: 193265,
            max: 241582,
          },
          700000: {
            min: 216640,
            max: 270795,
          },
          800000: {
            min: 242527,
            max: 303162,
          },
          900000: {
            min: 267161,
            max: 333955,
          },
          1000000: {
            min: 290530,
            max: 363161,
          },
        },
        Schwierigkeitsstufe: {
          1500: {
            min: 2368,
            max: 2840,
          },
          5000: {
            min: 7897,
            max: 9477,
          },
          10000: {
            min: 13110,
            max: 15731,
          },
          20000: {
            min: 21794,
            max: 26147,
          },
          40000: {
            min: 35371,
            max: 42440,
          },
          60000: {
            min: 44527,
            max: 53430,
          },
          80000: {
            min: 53053,
            max: 63666,
          },
          100000: {
            min: 60005,
            max: 72002,
          },
          150000: {
            min: 82900,
            max: 99475,
          },
          200000: {
            min: 104211,
            max: 125055,
          },
          250000: {
            min: 126320,
            max: 151578,
          },
          300000: {
            min: 146848,
            max: 176218,
          },
          350000: {
            min: 165791,
            max: 198950,
          },
          400000: {
            min: 183163,
            max: 219794,
          },
          450000: {
            min: 198950,
            max: 238736,
          },
          500000: {
            min: 213164,
            max: 255795,
          },
          600000: {
            min: 241582,
            max: 289900,
          },
          700000: {
            min: 270795,
            max: 324950,
          },
          800000: {
            min: 303162,
            max: 363791,
          },
          900000: {
            min: 333955,
            max: 400742,
          },
          1000000: {
            min: 363161,
            max: 435793,
          },
        },
      },
      phases: [
        {
          title:
            'Klären der Aufgabenstellung und Ermitteln des Leistungsumfangs',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Planfassung – Vorentwurf -',
          maxPercent: '50',
        },
        {
          title: 'Entwurf',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 30 Abs. 1 - Landschaftsrahmenplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        Normalstufe: {
          5000: {
            min: 32402,
            max: 40500,
          },
          6000: {
            min: 37249,
            max: 46563,
          },
          7000: {
            min: 41822,
            max: 52278,
          },
          8000: {
            min: 46130,
            max: 57665,
          },
          9000: {
            min: 50021,
            max: 62530,
          },
          10000: {
            min: 53526,
            max: 66911,
          },
          12000: {
            min: 60005,
            max: 75005,
          },
          14000: {
            min: 65696,
            max: 82125,
          },
          16000: {
            min: 71140,
            max: 88930,
          },
          18000: {
            min: 76168,
            max: 95213,
          },
          20000: {
            min: 81534,
            max: 101922,
          },
          25000: {
            min: 94897,
            max: 118626,
          },
          30000: {
            min: 106106,
            max: 132636,
          },
          35000: {
            min: 115611,
            max: 144520,
          },
          40000: {
            min: 123789,
            max: 154739,
          },
          45000: {
            min: 130419,
            max: 163029,
          },
          50000: {
            min: 138002,
            max: 172505,
          },
          60000: {
            min: 151894,
            max: 189868,
          },
          70000: {
            min: 164463,
            max: 205582,
          },
          80000: {
            min: 174317,
            max: 217899,
          },
          90000: {
            min: 184171,
            max: 230216,
          },
          100000: {
            min: 194531,
            max: 243163,
          },
        },
        Schwierigkeitsstufe: {
          5000: {
            min: 40500,
            max: 48599,
          },
          6000: {
            min: 46563,
            max: 55877,
          },
          7000: {
            min: 52278,
            max: 62732,
          },
          8000: {
            min: 57665,
            max: 69194,
          },
          9000: {
            min: 62530,
            max: 75032,
          },
          10000: {
            min: 66911,
            max: 80297,
          },
          12000: {
            min: 75005,
            max: 89999,
          },
          14000: {
            min: 82125,
            max: 98548,
          },
          16000: {
            min: 88930,
            max: 106714,
          },
          18000: {
            min: 95213,
            max: 114256,
          },
          20000: {
            min: 101922,
            max: 122305,
          },
          25000: {
            min: 118626,
            max: 142349,
          },
          30000: {
            min: 132636,
            max: 159159,
          },
          35000: {
            min: 144520,
            max: 173423,
          },
          40000: {
            min: 154739,
            max: 185683,
          },
          45000: {
            min: 163029,
            max: 195633,
          },
          50000: {
            min: 172505,
            max: 207005,
          },
          60000: {
            min: 189868,
            max: 227842,
          },
          70000: {
            min: 205582,
            max: 246695,
          },
          80000: {
            min: 217899,
            max: 261476,
          },
          90000: {
            min: 230216,
            max: 276255,
          },
          100000: {
            min: 243163,
            max: 291789,
          },
        },
      },
      phases: [
        {
          title: 'Landschaftsanalyse',
          maxPercent: '20',
        },
        {
          title: 'Landschaftsdiagnose',
          maxPercent: '20',
        },
        {
          title: 'Entwurf',
          maxPercent: '50',
        },
        {
          title: 'Endgültige Planfassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 31 Abs. 1 Pflege- Entwicklungsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          5: {
            min: 2576,
            max: 5146,
          },
          10: {
            min: 3240,
            max: 6474,
          },
          15: {
            min: 3713,
            max: 7424,
          },
          20: {
            min: 4083,
            max: 8161,
          },
          30: {
            min: 4736,
            max: 9477,
          },
          40: {
            min: 5326,
            max: 10658,
          },
          50: {
            min: 5843,
            max: 11688,
          },
          75: {
            min: 6940,
            max: 13886,
          },
          100: {
            min: 7868,
            max: 15731,
          },
          150: {
            min: 9342,
            max: 18673,
          },
          200: {
            min: 10432,
            max: 20871,
          },
          300: {
            min: 11906,
            max: 23813,
          },
          400: {
            min: 13009,
            max: 26017,
          },
          500: {
            min: 13897,
            max: 27789,
          },
          1000: {
            min: 17570,
            max: 35134,
          },
          2500: {
            min: 26389,
            max: 52773,
          },
          5000: {
            min: 37412,
            max: 74824,
          },
          10000: {
            min: 52114,
            max: 104222,
          },
        },
        II: {
          5: {
            min: 5146,
            max: 7722,
          },
          10: {
            min: 6474,
            max: 9702,
          },
          15: {
            min: 7424,
            max: 11136,
          },
          20: {
            min: 8161,
            max: 12239,
          },
          30: {
            min: 9477,
            max: 14224,
          },
          40: {
            min: 10658,
            max: 15984,
          },
          50: {
            min: 11688,
            max: 17525,
          },
          75: {
            min: 13886,
            max: 20837,
          },
          100: {
            min: 15731,
            max: 23599,
          },
          150: {
            min: 18673,
            max: 28008,
          },
          200: {
            min: 20871,
            max: 31310,
          },
          300: {
            min: 23813,
            max: 35719,
          },
          400: {
            min: 26017,
            max: 39032,
          },
          500: {
            min: 27789,
            max: 41676,
          },
          1000: {
            min: 35134,
            max: 52704,
          },
          2500: {
            min: 52773,
            max: 79160,
          },
          5000: {
            min: 74824,
            max: 112231,
          },
          10000: {
            min: 104222,
            max: 156336,
          },
        },
        III: {
          5: {
            min: 7722,
            max: 10293,
          },
          10: {
            min: 9702,
            max: 12936,
          },
          15: {
            min: 11136,
            max: 14848,
          },
          20: {
            min: 12239,
            max: 16316,
          },
          30: {
            min: 14224,
            max: 18965,
          },
          40: {
            min: 15984,
            max: 21316,
          },
          50: {
            min: 17525,
            max: 23368,
          },
          75: {
            min: 20837,
            max: 27784,
          },
          100: {
            min: 23599,
            max: 31462,
          },
          150: {
            min: 28008,
            max: 37340,
          },
          200: {
            min: 31310,
            max: 41748,
          },
          300: {
            min: 35719,
            max: 47626,
          },
          400: {
            min: 39032,
            max: 52041,
          },
          500: {
            min: 41676,
            max: 55568,
          },
          1000: {
            min: 52704,
            max: 70269,
          },
          2500: {
            min: 79160,
            max: 105544,
          },
          5000: {
            min: 112231,
            max: 149643,
          },
          10000: {
            min: 156336,
            max: 208445,
          },
        },
      },
      phases: [
        {
          title: 'Zusammenstellen der Ausgangsbedingungen',
          maxPercent: '5',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '50',
        },
        {
          title: 'Konzept der Pflege und Entwicklungsmaßnahmen',
          maxPercent: '40',
        },
        {
          title: 'Endgültige Planfassung',
          maxPercent: '5',
        },
      ],
    },
    {
      label: '§ 39 Abs. 1 Freianlagen',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['500'],
      disabledCostGroups: [
        'gewässer',
        'teiche',
        'erdbau',
        'durchlaesse',
        'laermschutz',
        'stuetzbauwerk',
        'stege',
        'wege',
      ],
      additionalFields: [
        {
          label:
            'Einzelgewässer mit überwiegend ökologischen und landschaftsgestalterischen Elementen nach §37 Abs. 1 Nr. 1',
          key: 'gewässer',
        },
        {
          label: 'Teiche ohne Dämme nach §37 Abs. 1 Nr. 2',
          key: 'teiche',
        },
        {
          label:
            'Flächenhafter Erdbau zur Geländegestaltung nach §37 Abs. 1 Nr. 3',
          key: 'erdbau',
        },
        {
          label:
            'Einfache Durchlässe und Uferbefestigungen als Mittel zur Geländegestaltung nach §37 Abs. 1 Nr. 4',
          key: 'durchlaesse',
        },
        {
          label:
            'Lärmschutzwälle als Mittel zur Geländegestaltung nach §37 Abs. 1 Nr. 5',
          key: 'laermschutz',
        },
        {
          label:
            'Stützbauwerke und Geländeabstützungen ohne Verkehrsbelastung als Mittel zur Geländegestaltung nach §37 Abs. 1 Nr. 6',
          key: 'stuetzbauwerk',
        },
        {
          label: 'Stege und Brücken nach §37 Abs. 1 Nr. 7',
          key: 'stege',
        },
        {
          label:
            'Wege ohne Eignung für den regelmäßigen Fahrverkehr mit einfachen Entwässerungsverhältnissen sowie andere Wege und befestigte Flächen, die als Gestaltungselement der Freianlagen geplant werden nach §37 Abs. 1 Nr. 8',
          key: 'wege',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          acc += el.costs ?? 0;
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        return other;
      },
      honorariumZone: {
        I: {
          20452: {
            min: 2616,
            max: 3205,
          },
          25000: {
            min: 3186,
            max: 3902,
          },
          30000: {
            min: 3798,
            max: 4651,
          },
          35000: {
            min: 4409,
            max: 5394,
          },
          40000: {
            min: 5015,
            max: 6133,
          },
          45000: {
            min: 5610,
            max: 6861,
          },
          50000: {
            min: 6200,
            max: 7578,
          },
          100000: {
            min: 11730,
            max: 14276,
          },
          150000: {
            min: 16590,
            max: 20103,
          },
          200000: {
            min: 20814,
            max: 25089,
          },
          250000: {
            min: 24364,
            max: 29196,
          },
          300000: {
            min: 29051,
            max: 34471,
          },
          350000: {
            min: 33897,
            max: 39806,
          },
          400000: {
            min: 38737,
            max: 45026,
          },
          450000: {
            min: 43581,
            max: 50122,
          },
          500000: {
            min: 48418,
            max: 55091,
          },
          1000000: {
            min: 96839,
            max: 107026,
          },
          1500000: {
            min: 145255,
            max: 159689,
          },
          1533876: {
            min: 148535,
            max: 163260,
          },
        },
        II: {
          20452: {
            min: 3205,
            max: 3988,
          },
          25000: {
            min: 3902,
            max: 4853,
          },
          30000: {
            min: 4651,
            max: 5785,
          },
          35000: {
            min: 5394,
            max: 6710,
          },
          40000: {
            min: 6133,
            max: 7624,
          },
          45000: {
            min: 6861,
            max: 8524,
          },
          50000: {
            min: 7578,
            max: 9412,
          },
          100000: {
            min: 14276,
            max: 17665,
          },
          150000: {
            min: 20103,
            max: 24785,
          },
          200000: {
            min: 25089,
            max: 30781,
          },
          250000: {
            min: 29196,
            max: 35638,
          },
          300000: {
            min: 34471,
            max: 41693,
          },
          350000: {
            min: 39806,
            max: 47685,
          },
          400000: {
            min: 45026,
            max: 53411,
          },
          450000: {
            min: 50122,
            max: 58839,
          },
          500000: {
            min: 55091,
            max: 63989,
          },
          1000000: {
            min: 107026,
            max: 120607,
          },
          1500000: {
            min: 159689,
            max: 178937,
          },
          1533876: {
            min: 163260,
            max: 182894,
          },
        },
        III: {
          20452: {
            min: 3988,
            max: 5163,
          },
          25000: {
            min: 4853,
            max: 6279,
          },
          30000: {
            min: 5785,
            max: 7486,
          },
          35000: {
            min: 6710,
            max: 8676,
          },
          40000: {
            min: 7624,
            max: 9855,
          },
          45000: {
            min: 8524,
            max: 11019,
          },
          50000: {
            min: 9412,
            max: 12162,
          },
          100000: {
            min: 17665,
            max: 22756,
          },
          150000: {
            min: 24785,
            max: 31810,
          },
          200000: {
            min: 30781,
            max: 39329,
          },
          250000: {
            min: 35638,
            max: 45308,
          },
          300000: {
            min: 41693,
            max: 52534,
          },
          350000: {
            min: 47685,
            max: 59505,
          },
          400000: {
            min: 53411,
            max: 65990,
          },
          450000: {
            min: 58839,
            max: 71915,
          },
          500000: {
            min: 63989,
            max: 77340,
          },
          1000000: {
            min: 120607,
            max: 140982,
          },
          1500000: {
            min: 178937,
            max: 207811,
          },
          1533876: {
            min: 182894,
            max: 212347,
          },
        },
        IV: {
          20452: {
            min: 5163,
            max: 5944,
          },
          25000: {
            min: 6279,
            max: 7230,
          },
          30000: {
            min: 7486,
            max: 8620,
          },
          35000: {
            min: 8676,
            max: 9991,
          },
          40000: {
            min: 9855,
            max: 11348,
          },
          45000: {
            min: 11019,
            max: 12682,
          },
          50000: {
            min: 12162,
            max: 13995,
          },
          100000: {
            min: 22756,
            max: 26145,
          },
          150000: {
            min: 31810,
            max: 36491,
          },
          200000: {
            min: 39329,
            max: 45022,
          },
          250000: {
            min: 45308,
            max: 51750,
          },
          300000: {
            min: 52534,
            max: 59755,
          },
          350000: {
            min: 59505,
            max: 67384,
          },
          400000: {
            min: 65990,
            max: 74373,
          },
          450000: {
            min: 71915,
            max: 80633,
          },
          500000: {
            min: 77340,
            max: 86238,
          },
          1000000: {
            min: 140982,
            max: 154563,
          },
          1500000: {
            min: 207811,
            max: 227058,
          },
          1533876: {
            min: 212347,
            max: 231982,
          },
        },
        V: {
          20452: {
            min: 5944,
            max: 6535,
          },
          25000: {
            min: 7230,
            max: 7946,
          },
          30000: {
            min: 8620,
            max: 9468,
          },
          35000: {
            min: 9991,
            max: 10977,
          },
          40000: {
            min: 11348,
            max: 12465,
          },
          45000: {
            min: 12682,
            max: 13932,
          },
          50000: {
            min: 13995,
            max: 15373,
          },
          100000: {
            min: 26145,
            max: 28690,
          },
          150000: {
            min: 36491,
            max: 40004,
          },
          200000: {
            min: 45022,
            max: 49297,
          },
          250000: {
            min: 51750,
            max: 56582,
          },
          300000: {
            min: 59755,
            max: 65175,
          },
          350000: {
            min: 67384,
            max: 73293,
          },
          400000: {
            min: 74373,
            max: 80663,
          },
          450000: {
            min: 80633,
            max: 87173,
          },
          500000: {
            min: 86238,
            max: 92912,
          },
          1000000: {
            min: 154563,
            max: 164750,
          },
          1500000: {
            min: 227058,
            max: 241492,
          },
          1533876: {
            min: 231982,
            max: 246706,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Vorplanung',
          maxPercent: '10',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '15',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '6',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '24',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '7',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '3',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung',
          maxPercent: '29',
        },
        {
          title: 'Objektbetreuung und Dokumentation',
          maxPercent: '3',
        },
      ],
    },
    {
      label: '§ 43 Abs. 1 Ingenieurbauwerke',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '500'],
      disabledCostGroups: [
        '200',
        '500',
        'maschinentechnik',
        'leitungen',
        'verkehr',
        'ausstattung',
      ],
      additionalFields: [
        {
          label: 'Kosten für die Anlagen der Maschinentechnik nach §41 Abs. 1',
          key: 'maschinentechnik',
        },
        {
          label: 'Umlegen und Verlegen von Leitungen nach §41 Abs. 3',
          key: 'leitungen',
        },
        {
          label:
            'Verkehrsregelnde Maßnahmen während der Bauzeit nach §41 Abs. 3',
          key: 'verkehr',
        },
        {
          label:
            'Anlagen der Maschinentechnik, die der Zweckbestimmung des Ingenieurbauwerks dienen nach §41 Abs. 3',
          key: 'ausstattung',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25565: {
            min: 2616,
            max: 3290,
          },
          30000: {
            min: 2981,
            max: 3735,
          },
          35000: {
            min: 3375,
            max: 4215,
          },
          40000: {
            min: 3751,
            max: 4681,
          },
          45000: {
            min: 4125,
            max: 5134,
          },
          50000: {
            min: 4495,
            max: 5585,
          },
          75000: {
            min: 6233,
            max: 7687,
          },
          100000: {
            min: 7863,
            max: 9649,
          },
          150000: {
            min: 10902,
            max: 13286,
          },
          200000: {
            min: 13753,
            max: 16680,
          },
          250000: {
            min: 16467,
            max: 19892,
          },
          300000: {
            min: 19070,
            max: 22970,
          },
          350000: {
            min: 21593,
            max: 25948,
          },
          400000: {
            min: 24056,
            max: 28839,
          },
          450000: {
            min: 26451,
            max: 31653,
          },
          500000: {
            min: 28793,
            max: 34399,
          },
          750000: {
            min: 39906,
            max: 47363,
          },
          1000000: {
            min: 50338,
            max: 59468,
          },
          1500000: {
            min: 69798,
            max: 81930,
          },
          2000000: {
            min: 88043,
            max: 102884,
          },
          2500000: {
            min: 105403,
            max: 122755,
          },
          3000000: {
            min: 122104,
            max: 141804,
          },
          3500000: {
            min: 138269,
            max: 160202,
          },
          4000000: {
            min: 154001,
            max: 178067,
          },
          4500000: {
            min: 169349,
            max: 195466,
          },
          5000000: {
            min: 184370,
            max: 212464,
          },
          7500000: {
            min: 255540,
            max: 292695,
          },
          10000000: {
            min: 322325,
            max: 367629,
          },
          15000000: {
            min: 446895,
            max: 506699,
          },
          20000000: {
            min: 563691,
            max: 636474,
          },
          25000000: {
            min: 674891,
            max: 759620,
          },
          25564594: {
            min: 687391,
            max: 773458,
          },
        },
        II: {
          25565: {
            min: 3290,
            max: 3959,
          },
          30000: {
            min: 3735,
            max: 4487,
          },
          35000: {
            min: 4215,
            max: 5061,
          },
          40000: {
            min: 4681,
            max: 5610,
          },
          45000: {
            min: 5134,
            max: 6146,
          },
          50000: {
            min: 5585,
            max: 6675,
          },
          75000: {
            min: 7687,
            max: 9141,
          },
          100000: {
            min: 9649,
            max: 11436,
          },
          150000: {
            min: 13286,
            max: 15671,
          },
          200000: {
            min: 16680,
            max: 19606,
          },
          250000: {
            min: 19892,
            max: 23322,
          },
          300000: {
            min: 22970,
            max: 26877,
          },
          350000: {
            min: 25948,
            max: 30304,
          },
          400000: {
            min: 28839,
            max: 33626,
          },
          450000: {
            min: 31653,
            max: 36856,
          },
          500000: {
            min: 34399,
            max: 40002,
          },
          750000: {
            min: 47363,
            max: 54819,
          },
          1000000: {
            min: 59468,
            max: 68603,
          },
          1500000: {
            min: 81930,
            max: 94062,
          },
          2000000: {
            min: 102884,
            max: 117725,
          },
          2500000: {
            min: 122755,
            max: 140099,
          },
          3000000: {
            min: 141804,
            max: 161504,
          },
          3500000: {
            min: 160202,
            max: 182135,
          },
          4000000: {
            min: 178067,
            max: 202128,
          },
          4500000: {
            min: 195466,
            max: 221580,
          },
          5000000: {
            min: 212464,
            max: 240558,
          },
          7500000: {
            min: 292695,
            max: 329850,
          },
          10000000: {
            min: 367629,
            max: 412932,
          },
          15000000: {
            min: 506699,
            max: 566498,
          },
          20000000: {
            min: 636474,
            max: 709258,
          },
          25000000: {
            min: 759620,
            max: 844344,
          },
          25564594: {
            min: 773458,
            max: 859520,
          },
        },
        III: {
          25565: {
            min: 3959,
            max: 4634,
          },
          30000: {
            min: 4487,
            max: 5244,
          },
          35000: {
            min: 5061,
            max: 5904,
          },
          40000: {
            min: 5610,
            max: 6534,
          },
          45000: {
            min: 6146,
            max: 7152,
          },
          50000: {
            min: 6675,
            max: 7759,
          },
          75000: {
            min: 9141,
            max: 10591,
          },
          100000: {
            min: 11436,
            max: 13218,
          },
          150000: {
            min: 15671,
            max: 18053,
          },
          200000: {
            min: 19606,
            max: 22528,
          },
          250000: {
            min: 23322,
            max: 26748,
          },
          300000: {
            min: 26877,
            max: 30778,
          },
          350000: {
            min: 30304,
            max: 34654,
          },
          400000: {
            min: 33626,
            max: 38408,
          },
          450000: {
            min: 36856,
            max: 42052,
          },
          500000: {
            min: 40002,
            max: 45607,
          },
          750000: {
            min: 54819,
            max: 62275,
          },
          1000000: {
            min: 68603,
            max: 77733,
          },
          1500000: {
            min: 94062,
            max: 106198,
          },
          2000000: {
            min: 117725,
            max: 132572,
          },
          2500000: {
            min: 140099,
            max: 157451,
          },
          3000000: {
            min: 161504,
            max: 181210,
          },
          3500000: {
            min: 182135,
            max: 204063,
          },
          4000000: {
            min: 202128,
            max: 226193,
          },
          4500000: {
            min: 221580,
            max: 247691,
          },
          5000000: {
            min: 240558,
            max: 268655,
          },
          7500000: {
            min: 329850,
            max: 367006,
          },
          10000000: {
            min: 412932,
            max: 458236,
          },
          15000000: {
            min: 566498,
            max: 626302,
          },
          20000000: {
            min: 709258,
            max: 782047,
          },
          25000000: {
            min: 844344,
            max: 929073,
          },
          25564594: {
            min: 859520,
            max: 945588,
          },
        },
        IV: {
          25565: {
            min: 4634,
            max: 5303,
          },
          30000: {
            min: 5244,
            max: 5996,
          },
          35000: {
            min: 5904,
            max: 6749,
          },
          40000: {
            min: 6534,
            max: 7465,
          },
          45000: {
            min: 7152,
            max: 8165,
          },
          50000: {
            min: 7759,
            max: 8851,
          },
          75000: {
            min: 10591,
            max: 12045,
          },
          100000: {
            min: 13218,
            max: 15004,
          },
          150000: {
            min: 18053,
            max: 20437,
          },
          200000: {
            min: 22528,
            max: 25454,
          },
          250000: {
            min: 26748,
            max: 30177,
          },
          300000: {
            min: 30778,
            max: 34684,
          },
          350000: {
            min: 34654,
            max: 39010,
          },
          400000: {
            min: 38408,
            max: 43196,
          },
          450000: {
            min: 42052,
            max: 47255,
          },
          500000: {
            min: 45607,
            max: 51209,
          },
          750000: {
            min: 62275,
            max: 69732,
          },
          1000000: {
            min: 77733,
            max: 86868,
          },
          1500000: {
            min: 106198,
            max: 118330,
          },
          2000000: {
            min: 132572,
            max: 147413,
          },
          2500000: {
            min: 157451,
            max: 174797,
          },
          3000000: {
            min: 181210,
            max: 200910,
          },
          3500000: {
            min: 204063,
            max: 225996,
          },
          4000000: {
            min: 226193,
            max: 250254,
          },
          4500000: {
            min: 247691,
            max: 273807,
          },
          5000000: {
            min: 268655,
            max: 296748,
          },
          7500000: {
            min: 367006,
            max: 404161,
          },
          10000000: {
            min: 458236,
            max: 503540,
          },
          15000000: {
            min: 626302,
            max: 686100,
          },
          20000000: {
            min: 782047,
            max: 854831,
          },
          25000000: {
            min: 929073,
            max: 1013797,
          },
          25564594: {
            min: 945588,
            max: 1031649,
          },
        },
        V: {
          25565: {
            min: 5303,
            max: 5979,
          },
          30000: {
            min: 5996,
            max: 6750,
          },
          35000: {
            min: 6749,
            max: 7590,
          },
          40000: {
            min: 7465,
            max: 8393,
          },
          45000: {
            min: 8165,
            max: 9173,
          },
          50000: {
            min: 8851,
            max: 9940,
          },
          75000: {
            min: 12045,
            max: 13499,
          },
          100000: {
            min: 15004,
            max: 16790,
          },
          150000: {
            min: 20437,
            max: 22821,
          },
          200000: {
            min: 25454,
            max: 28381,
          },
          250000: {
            min: 30177,
            max: 33603,
          },
          300000: {
            min: 34684,
            max: 38586,
          },
          350000: {
            min: 39010,
            max: 43365,
          },
          400000: {
            min: 43196,
            max: 47979,
          },
          450000: {
            min: 47255,
            max: 52457,
          },
          500000: {
            min: 51209,
            max: 56816,
          },
          750000: {
            min: 69732,
            max: 77188,
          },
          1000000: {
            min: 86868,
            max: 95998,
          },
          1500000: {
            min: 118330,
            max: 130462,
          },
          2000000: {
            min: 147413,
            max: 162254,
          },
          2500000: {
            min: 174797,
            max: 192147,
          },
          3000000: {
            min: 200910,
            max: 220611,
          },
          3500000: {
            min: 225996,
            max: 247929,
          },
          4000000: {
            min: 250254,
            max: 274320,
          },
          4500000: {
            min: 273807,
            max: 299922,
          },
          5000000: {
            min: 296748,
            max: 324842,
          },
          7500000: {
            min: 404161,
            max: 441316,
          },
          10000000: {
            min: 503540,
            max: 548844,
          },
          15000000: {
            min: 686100,
            max: 745903,
          },
          20000000: {
            min: 854831,
            max: 927615,
          },
          25000000: {
            min: 1013797,
            max: 1098526,
          },
          25564594: {
            min: 1031649,
            max: 1117717,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '2',
        },
        {
          title: 'Vorplanung',
          maxPercent: '15',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '30',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '5',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '15',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '10',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '5',
        },
        {
          title: 'Bauoberleitung',
          maxPercent: '15',
        },
        {
          title: 'Objektbetreuung und Dokumentation',
          maxPercent: '3',
        },
      ],
    },
    {
      label: '§ 47 Abs. 1 Verkehrsanlagen',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '500'],
      disabledCostGroups: [
        '200',
        '500',
        'ausstattung',
        'nebenanlagen',
        'leitungen',
        'verkehr',
        'erdarbeiten',
        'ingenieur',
      ],
      additionalFields: [
        {
          label:
            'Ausstattungen, die der Zweckbestimmung der Verkehrsanlagen dienen nach §45 Abs. 1',
          key: 'ausstattung',
        },
        {
          label: 'Umlegen und Verlegen von Leitungen nach §45 Abs. 3 Nr. 2',
          key: 'leitungen',
        },
        {
          label:
            'Nebenanlagen von Anlagen des Straßen-, Schienen- und Flugverkehrs nach §45 Abs. 3 Nr. 3',
          key: 'nebenanlagen',
        },
        {
          label:
            'Verkehrsregelnde Maßnahmen während der Bauzeit nach §45 Abs. 3 Nr. 4',
          key: 'verkehr',
        },
        {
          label:
            'Kosten für Erdarbeiten einschließlich Felsarbeiten §45 Abs. 4 Nr. 1',
          key: 'erdarbeiten',
        },
        {
          label: 'Kosten für Ingenieurbauwerke §45 Abs. 4 Nr. 2',
          key: 'ingenieur',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const abs1 =
          (entries.find((el) => el.number == '300')?.costs ?? 0) +
          (additionalFields?.find((el) => el.key == 'ausstattung')?.costs ?? 0);

        const erdarbeiten = Math.min(
          additionalFields?.find((el) => el.key == 'erdarbeiten')?.costs ?? 0,
          abs1 * 0.4
        );

        const ingenieur =
          0.1 *
          (additionalFields?.find((el) => el.key == 'ingenieur')?.costs ?? 0);

        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400' && el.number != '300') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const additionalsAndCostGroups =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            if (
              el.key != 'ausstattung' &&
              el.key != 'erdarbeiten' &&
              el.key != 'ingenieur'
            ) {
              acc += el.costs ?? 0;
            }
            return acc;
          }, 0);

        const other = abs1 + erdarbeiten + ingenieur + additionalsAndCostGroups;

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25565: {
            min: 2874,
            max: 3610,
          },
          30000: {
            min: 3269,
            max: 4094,
          },
          35000: {
            min: 3700,
            max: 4624,
          },
          40000: {
            min: 4111,
            max: 5124,
          },
          45000: {
            min: 4518,
            max: 5619,
          },
          50000: {
            min: 4912,
            max: 6101,
          },
          75000: {
            min: 6775,
            max: 8357,
          },
          100000: {
            min: 8516,
            max: 10452,
          },
          150000: {
            min: 11718,
            max: 14280,
          },
          200000: {
            min: 14642,
            max: 17758,
          },
          250000: {
            min: 17381,
            max: 21002,
          },
          300000: {
            min: 19962,
            max: 24045,
          },
          350000: {
            min: 22410,
            max: 26927,
          },
          400000: {
            min: 24735,
            max: 29657,
          },
          450000: {
            min: 26954,
            max: 32254,
          },
          500000: {
            min: 29084,
            max: 34746,
          },
          750000: {
            min: 38446,
            max: 45634,
          },
          1000000: {
            min: 46193,
            max: 54575,
          },
          1500000: {
            min: 63820,
            max: 74911,
          },
          2000000: {
            min: 80496,
            max: 94064,
          },
          2500000: {
            min: 96370,
            max: 112231,
          },
          3000000: {
            min: 111639,
            max: 129652,
          },
          3500000: {
            min: 126423,
            max: 146474,
          },
          4000000: {
            min: 140808,
            max: 162808,
          },
          4500000: {
            min: 154832,
            max: 178710,
          },
          5000000: {
            min: 168563,
            max: 194249,
          },
          7500000: {
            min: 233640,
            max: 267609,
          },
          10000000: {
            min: 294697,
            max: 336115,
          },
          15000000: {
            min: 408590,
            max: 463264,
          },
          20000000: {
            min: 515368,
            max: 581913,
          },
          25000000: {
            min: 617043,
            max: 694507,
          },
          25564594: {
            min: 628472,
            max: 707160,
          },
        },
        II: {
          25565: {
            min: 3610,
            max: 4347,
          },
          30000: {
            min: 4094,
            max: 4918,
          },
          35000: {
            min: 4624,
            max: 5543,
          },
          40000: {
            min: 5124,
            max: 6141,
          },
          45000: {
            min: 5619,
            max: 6727,
          },
          50000: {
            min: 6101,
            max: 7292,
          },
          75000: {
            min: 8357,
            max: 9940,
          },
          100000: {
            min: 10452,
            max: 12389,
          },
          150000: {
            min: 14280,
            max: 16837,
          },
          200000: {
            min: 17758,
            max: 20875,
          },
          250000: {
            min: 21002,
            max: 24625,
          },
          300000: {
            min: 24045,
            max: 28133,
          },
          350000: {
            min: 26927,
            max: 31444,
          },
          400000: {
            min: 29657,
            max: 34579,
          },
          450000: {
            min: 32254,
            max: 37555,
          },
          500000: {
            min: 34746,
            max: 40407,
          },
          750000: {
            min: 45634,
            max: 52814,
          },
          1000000: {
            min: 54575,
            max: 62955,
          },
          1500000: {
            min: 74911,
            max: 86004,
          },
          2000000: {
            min: 94064,
            max: 107633,
          },
          2500000: {
            min: 112231,
            max: 128093,
          },
          3000000: {
            min: 129652,
            max: 147663,
          },
          3500000: {
            min: 146474,
            max: 166525,
          },
          4000000: {
            min: 162808,
            max: 184809,
          },
          4500000: {
            min: 178710,
            max: 202588,
          },
          5000000: {
            min: 194249,
            max: 219935,
          },
          7500000: {
            min: 267609,
            max: 301577,
          },
          10000000: {
            min: 336115,
            max: 377533,
          },
          15000000: {
            min: 463264,
            max: 517937,
          },
          20000000: {
            min: 581913,
            max: 648458,
          },
          25000000: {
            min: 694507,
            max: 771967,
          },
          25564594: {
            min: 707160,
            max: 785843,
          },
        },
        III: {
          25565: {
            min: 4347,
            max: 5090,
          },
          30000: {
            min: 4918,
            max: 5744,
          },
          35000: {
            min: 5543,
            max: 6467,
          },
          40000: {
            min: 6141,
            max: 7154,
          },
          45000: {
            min: 6727,
            max: 7828,
          },
          50000: {
            min: 7292,
            max: 8481,
          },
          75000: {
            min: 9940,
            max: 11527,
          },
          100000: {
            min: 12389,
            max: 14321,
          },
          150000: {
            min: 16837,
            max: 19399,
          },
          200000: {
            min: 20875,
            max: 23997,
          },
          250000: {
            min: 24625,
            max: 28241,
          },
          300000: {
            min: 28133,
            max: 32216,
          },
          350000: {
            min: 31444,
            max: 35955,
          },
          400000: {
            min: 34579,
            max: 39494,
          },
          450000: {
            min: 37555,
            max: 42855,
          },
          500000: {
            min: 40407,
            max: 46065,
          },
          750000: {
            min: 52814,
            max: 60001,
          },
          1000000: {
            min: 62955,
            max: 71332,
          },
          1500000: {
            min: 86004,
            max: 97100,
          },
          2000000: {
            min: 107633,
            max: 121207,
          },
          2500000: {
            min: 128093,
            max: 143956,
          },
          3000000: {
            min: 147663,
            max: 165675,
          },
          3500000: {
            min: 166525,
            max: 186575,
          },
          4000000: {
            min: 184809,
            max: 206806,
          },
          4500000: {
            min: 202588,
            max: 226461,
          },
          5000000: {
            min: 219935,
            max: 245623,
          },
          7500000: {
            min: 301577,
            max: 335551,
          },
          10000000: {
            min: 377533,
            max: 418957,
          },
          15000000: {
            min: 517937,
            max: 572617,
          },
          20000000: {
            min: 648458,
            max: 715009,
          },
          25000000: {
            min: 771967,
            max: 849433,
          },
          25564594: {
            min: 785843,
            max: 864531,
          },
        },
        IV: {
          25565: {
            min: 5090,
            max: 5827,
          },
          30000: {
            min: 5744,
            max: 6568,
          },
          35000: {
            min: 6467,
            max: 7385,
          },
          40000: {
            min: 7154,
            max: 8172,
          },
          45000: {
            min: 7828,
            max: 8934,
          },
          50000: {
            min: 8481,
            max: 9671,
          },
          75000: {
            min: 11527,
            max: 13109,
          },
          100000: {
            min: 14321,
            max: 16258,
          },
          150000: {
            min: 19399,
            max: 21955,
          },
          200000: {
            min: 23997,
            max: 27113,
          },
          250000: {
            min: 28241,
            max: 31864,
          },
          300000: {
            min: 32216,
            max: 36303,
          },
          350000: {
            min: 35955,
            max: 40471,
          },
          400000: {
            min: 39494,
            max: 44417,
          },
          450000: {
            min: 42855,
            max: 48156,
          },
          500000: {
            min: 46065,
            max: 51725,
          },
          750000: {
            min: 60001,
            max: 67181,
          },
          1000000: {
            min: 71332,
            max: 79713,
          },
          1500000: {
            min: 97100,
            max: 108192,
          },
          2000000: {
            min: 121207,
            max: 134775,
          },
          2500000: {
            min: 143956,
            max: 159818,
          },
          3000000: {
            min: 165675,
            max: 183687,
          },
          3500000: {
            min: 186575,
            max: 206626,
          },
          4000000: {
            min: 206806,
            max: 228806,
          },
          4500000: {
            min: 226461,
            max: 250339,
          },
          5000000: {
            min: 245623,
            max: 271310,
          },
          7500000: {
            min: 335551,
            max: 369519,
          },
          10000000: {
            min: 418957,
            max: 460375,
          },
          15000000: {
            min: 572617,
            max: 627292,
          },
          20000000: {
            min: 715009,
            max: 781553,
          },
          25000000: {
            min: 849433,
            max: 926893,
          },
          25564594: {
            min: 864531,
            max: 943214,
          },
        },
        V: {
          25565: {
            min: 5827,
            max: 6564,
          },
          30000: {
            min: 6568,
            max: 7393,
          },
          35000: {
            min: 7385,
            max: 8309,
          },
          40000: {
            min: 8172,
            max: 9185,
          },
          45000: {
            min: 8934,
            max: 10035,
          },
          50000: {
            min: 9671,
            max: 10861,
          },
          75000: {
            min: 13109,
            max: 14691,
          },
          100000: {
            min: 16258,
            max: 18195,
          },
          150000: {
            min: 21955,
            max: 24517,
          },
          200000: {
            min: 27113,
            max: 30230,
          },
          250000: {
            min: 31864,
            max: 35485,
          },
          300000: {
            min: 36303,
            max: 40387,
          },
          350000: {
            min: 40471,
            max: 44987,
          },
          400000: {
            min: 44417,
            max: 49338,
          },
          450000: {
            min: 48156,
            max: 53457,
          },
          500000: {
            min: 51725,
            max: 57387,
          },
          750000: {
            min: 67181,
            max: 74368,
          },
          1000000: {
            min: 79713,
            max: 88094,
          },
          1500000: {
            min: 108192,
            max: 119283,
          },
          2000000: {
            min: 134775,
            max: 148344,
          },
          2500000: {
            min: 159818,
            max: 175680,
          },
          3000000: {
            min: 183687,
            max: 201699,
          },
          3500000: {
            min: 206626,
            max: 226677,
          },
          4000000: {
            min: 228806,
            max: 250807,
          },
          4500000: {
            min: 250339,
            max: 274218,
          },
          5000000: {
            min: 271310,
            max: 296996,
          },
          7500000: {
            min: 369519,
            max: 403487,
          },
          10000000: {
            min: 460375,
            max: 501794,
          },
          15000000: {
            min: 627292,
            max: 681965,
          },
          20000000: {
            min: 781553,
            max: 848098,
          },
          25000000: {
            min: 926893,
            max: 1004357,
          },
          25564594: {
            min: 943214,
            max: 1021902,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '2',
        },
        {
          title: 'Vorplanung',
          maxPercent: '15',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '30',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '5',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '15',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '10',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '5',
        },
        {
          title: 'Bauoberleitung',
          maxPercent: '15',
        },
        {
          title: 'Objektbetreuung und Dokumentation',
          maxPercent: '3',
        },
      ],
    },
    {
      label: '§ 50 Abs. 1 Tragwerksplanung',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: [],
      disabledCostGroups: [],
      additionalFields: [
        {
          label:
            'Gebäuden und zugehörigen baulichen Anlagen - Baukonstruktionskosten nach §48 Abs. 1',
          key: 'gebBaukonst',
        },
        {
          label:
            'Gebäuden und zugehörigen baulichen Anlagen - Technischen Anlagen nach §48 Abs. 1',
          key: 'gebTechAnl',
        },
        {
          label: 'Anrechenbare Kosten bei Ingenieurbauwerken nach §48 Abs. 3',
          key: 'ingenieur',
        },
        {
          label:
            'Ingenieurbauwerken - Herstellkosten einschließlich der zugehörigen Kosten für Baustelleneinrichtungen von Traggerüsten nach §48 Abs. 5',
          key: 'ingTrag',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const gebBaukonst =
          0.55 *
          (additionalFields.find((el) => el.key == 'gebBaukonst')?.costs ?? 0);
        const gebTechAnl =
          0.1 *
          (additionalFields.find((el) => el.key == 'gebTechAnl')?.costs ?? 0);
        const ingenieur =
          additionalFields.find((el) => el.key == 'ingenieur')?.costs ?? 0;
        const ingTrag =
          additionalFields.find((el) => el.key == 'ingTrag')?.costs ?? 0;

        return gebBaukonst + gebTechAnl + ingenieur + ingTrag;
      },
      honorariumZone: {
        I: {
          10226: {
            min: 1119,
            max: 1305,
          },
          15000: {
            min: 1539,
            max: 1783,
          },
          20000: {
            min: 1948,
            max: 2247,
          },
          25000: {
            min: 2335,
            max: 2690,
          },
          30000: {
            min: 2716,
            max: 3120,
          },
          35000: {
            min: 3086,
            max: 3539,
          },
          40000: {
            min: 3435,
            max: 3938,
          },
          45000: {
            min: 3792,
            max: 4340,
          },
          50000: {
            min: 4132,
            max: 4723,
          },
          75000: {
            min: 5762,
            max: 6557,
          },
          100000: {
            min: 7292,
            max: 8276,
          },
          150000: {
            min: 10166,
            max: 11493,
          },
          200000: {
            min: 12872,
            max: 14515,
          },
          250000: {
            min: 15452,
            max: 17388,
          },
          300000: {
            min: 17952,
            max: 20165,
          },
          350000: {
            min: 20368,
            max: 22846,
          },
          400000: {
            min: 22729,
            max: 25457,
          },
          450000: {
            min: 25038,
            max: 28014,
          },
          500000: {
            min: 27298,
            max: 30512,
          },
          750000: {
            min: 38041,
            max: 42364,
          },
          1000000: {
            min: 48166,
            max: 53503,
          },
          1500000: {
            min: 67164,
            max: 74329,
          },
          2000000: {
            min: 85039,
            max: 93876,
          },
          2500000: {
            min: 102126,
            max: 112520,
          },
          3000000: {
            min: 118606,
            max: 130468,
          },
          3500000: {
            min: 134591,
            max: 147857,
          },
          4000000: {
            min: 150174,
            max: 164787,
          },
          4500000: {
            min: 165403,
            max: 181315,
          },
          5000000: {
            min: 180330,
            max: 197500,
          },
          7500000: {
            min: 251338,
            max: 274330,
          },
          10000000: {
            min: 318266,
            max: 346554,
          },
          15000000: {
            min: 443713,
            max: 481549,
          },
          15338756: {
            min: 452187,
            max: 490667,
          },
        },
        II: {
          10226: {
            min: 1305,
            max: 1760,
          },
          15000: {
            min: 1783,
            max: 2385,
          },
          20000: {
            min: 2247,
            max: 2999,
          },
          25000: {
            min: 2690,
            max: 3574,
          },
          30000: {
            min: 3120,
            max: 4132,
          },
          35000: {
            min: 3539,
            max: 4673,
          },
          40000: {
            min: 3938,
            max: 5189,
          },
          45000: {
            min: 4340,
            max: 5705,
          },
          50000: {
            min: 4723,
            max: 6200,
          },
          75000: {
            min: 6557,
            max: 8547,
          },
          100000: {
            min: 8276,
            max: 10737,
          },
          150000: {
            min: 11493,
            max: 14809,
          },
          200000: {
            min: 14515,
            max: 18612,
          },
          250000: {
            min: 17388,
            max: 22221,
          },
          300000: {
            min: 20165,
            max: 25691,
          },
          350000: {
            min: 22846,
            max: 29030,
          },
          400000: {
            min: 25457,
            max: 32283,
          },
          450000: {
            min: 28014,
            max: 35450,
          },
          500000: {
            min: 30512,
            max: 38548,
          },
          750000: {
            min: 42364,
            max: 53167,
          },
          1000000: {
            min: 53503,
            max: 66836,
          },
          1500000: {
            min: 74329,
            max: 92237,
          },
          2000000: {
            min: 93876,
            max: 115959,
          },
          2500000: {
            min: 112520,
            max: 138494,
          },
          3000000: {
            min: 130468,
            max: 160118,
          },
          3500000: {
            min: 147857,
            max: 181013,
          },
          4000000: {
            min: 164787,
            max: 201308,
          },
          4500000: {
            min: 181315,
            max: 221086,
          },
          5000000: {
            min: 197500,
            max: 240424,
          },
          7500000: {
            min: 274330,
            max: 331806,
          },
          10000000: {
            min: 346554,
            max: 417271,
          },
          15000000: {
            min: 481549,
            max: 576137,
          },
          15338756: {
            min: 490667,
            max: 586864,
          },
        },
        III: {
          10226: {
            min: 1760,
            max: 2306,
          },
          15000: {
            min: 2385,
            max: 3110,
          },
          20000: {
            min: 2999,
            max: 3894,
          },
          25000: {
            min: 3574,
            max: 4635,
          },
          30000: {
            min: 4132,
            max: 5348,
          },
          35000: {
            min: 4673,
            max: 6029,
          },
          40000: {
            min: 5189,
            max: 6697,
          },
          45000: {
            min: 5705,
            max: 7344,
          },
          50000: {
            min: 6200,
            max: 7970,
          },
          75000: {
            min: 8547,
            max: 10935,
          },
          100000: {
            min: 10737,
            max: 13695,
          },
          150000: {
            min: 14809,
            max: 18795,
          },
          200000: {
            min: 18612,
            max: 23533,
          },
          250000: {
            min: 22221,
            max: 28017,
          },
          300000: {
            min: 25691,
            max: 32316,
          },
          350000: {
            min: 29030,
            max: 36457,
          },
          400000: {
            min: 32283,
            max: 40470,
          },
          450000: {
            min: 35450,
            max: 44377,
          },
          500000: {
            min: 38548,
            max: 48192,
          },
          750000: {
            min: 53167,
            max: 66138,
          },
          1000000: {
            min: 66836,
            max: 82834,
          },
          1500000: {
            min: 92237,
            max: 113733,
          },
          2000000: {
            min: 115959,
            max: 142467,
          },
          2500000: {
            min: 138494,
            max: 169668,
          },
          3000000: {
            min: 160118,
            max: 195700,
          },
          3500000: {
            min: 181013,
            max: 220805,
          },
          4000000: {
            min: 201308,
            max: 245143,
          },
          4500000: {
            min: 221086,
            max: 268819,
          },
          5000000: {
            min: 240424,
            max: 291932,
          },
          7500000: {
            min: 331806,
            max: 400777,
          },
          10000000: {
            min: 417271,
            max: 502132,
          },
          15000000: {
            min: 576137,
            max: 689642,
          },
          15338756: {
            min: 586864,
            max: 702301,
          },
        },
        IV: {
          10226: {
            min: 2306,
            max: 2768,
          },
          15000: {
            min: 3110,
            max: 3713,
          },
          20000: {
            min: 3894,
            max: 4646,
          },
          25000: {
            min: 4635,
            max: 5521,
          },
          30000: {
            min: 5348,
            max: 6360,
          },
          35000: {
            min: 6029,
            max: 7163,
          },
          40000: {
            min: 6697,
            max: 7946,
          },
          45000: {
            min: 7344,
            max: 8710,
          },
          50000: {
            min: 7970,
            max: 9447,
          },
          75000: {
            min: 10935,
            max: 12925,
          },
          100000: {
            min: 13695,
            max: 16155,
          },
          150000: {
            min: 18795,
            max: 22111,
          },
          200000: {
            min: 23533,
            max: 27631,
          },
          250000: {
            min: 28017,
            max: 32849,
          },
          300000: {
            min: 32316,
            max: 37841,
          },
          350000: {
            min: 36457,
            max: 42647,
          },
          400000: {
            min: 40470,
            max: 47297,
          },
          450000: {
            min: 44377,
            max: 51813,
          },
          500000: {
            min: 48192,
            max: 56224,
          },
          750000: {
            min: 66138,
            max: 76940,
          },
          1000000: {
            min: 82834,
            max: 96173,
          },
          1500000: {
            min: 113733,
            max: 131643,
          },
          2000000: {
            min: 142467,
            max: 164555,
          },
          2500000: {
            min: 169668,
            max: 195644,
          },
          3000000: {
            min: 195700,
            max: 225352,
          },
          3500000: {
            min: 220805,
            max: 253966,
          },
          4000000: {
            min: 245143,
            max: 281665,
          },
          4500000: {
            min: 268819,
            max: 308594,
          },
          5000000: {
            min: 291932,
            max: 334859,
          },
          7500000: {
            min: 400777,
            max: 458253,
          },
          10000000: {
            min: 502132,
            max: 572849,
          },
          15000000: {
            min: 689642,
            max: 784230,
          },
          15338756: {
            min: 702301,
            max: 798498,
          },
        },
        V: {
          10226: {
            min: 2768,
            max: 2947,
          },
          15000: {
            min: 3713,
            max: 3956,
          },
          20000: {
            min: 4646,
            max: 4945,
          },
          25000: {
            min: 5521,
            max: 5874,
          },
          30000: {
            min: 6360,
            max: 6764,
          },
          35000: {
            min: 7163,
            max: 7616,
          },
          40000: {
            min: 7946,
            max: 8449,
          },
          45000: {
            min: 8710,
            max: 9258,
          },
          50000: {
            min: 9447,
            max: 10039,
          },
          75000: {
            min: 12925,
            max: 13721,
          },
          100000: {
            min: 16155,
            max: 17139,
          },
          150000: {
            min: 22111,
            max: 23439,
          },
          200000: {
            min: 27631,
            max: 29273,
          },
          250000: {
            min: 32849,
            max: 34785,
          },
          300000: {
            min: 37841,
            max: 40054,
          },
          350000: {
            min: 42647,
            max: 45120,
          },
          400000: {
            min: 47297,
            max: 50024,
          },
          450000: {
            min: 51813,
            max: 54789,
          },
          500000: {
            min: 56224,
            max: 59439,
          },
          750000: {
            min: 76940,
            max: 81264,
          },
          1000000: {
            min: 96173,
            max: 101504,
          },
          1500000: {
            min: 131643,
            max: 138807,
          },
          2000000: {
            min: 164555,
            max: 173386,
          },
          2500000: {
            min: 195644,
            max: 206037,
          },
          3000000: {
            min: 225352,
            max: 237212,
          },
          3500000: {
            min: 253966,
            max: 267227,
          },
          4000000: {
            min: 281665,
            max: 296276,
          },
          4500000: {
            min: 308594,
            max: 324502,
          },
          5000000: {
            min: 334859,
            max: 352028,
          },
          7500000: {
            min: 458253,
            max: 481246,
          },
          10000000: {
            min: 572849,
            max: 601137,
          },
          15000000: {
            min: 784230,
            max: 822066,
          },
          15338756: {
            min: 798498,
            max: 836978,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Vorplanung',
          maxPercent: '10',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '12',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '30',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '42',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '3',
        },
      ],
    },
    {
      label: '§ 54 Abs. 1 Technischen Ausrüstung',
      unitLabel: 'Anrechenbare Kosten',
      unit: 'euro',
      shownCostGroups: ['400'],
      disabledCostGroups: [],
      additionalFields: [],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          acc += el.costs ?? 0;

          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        return other;
      },
      honorariumZone: {
        I: {
          5113: {
            min: 1626,
            max: 2109,
          },
          7500: {
            min: 2234,
            max: 2886,
          },
          10000: {
            min: 2812,
            max: 3618,
          },
          15000: {
            min: 3903,
            max: 4981,
          },
          20000: {
            min: 4920,
            max: 6262,
          },
          25000: {
            min: 5882,
            max: 7489,
          },
          30000: {
            min: 6795,
            max: 8670,
          },
          35000: {
            min: 7674,
            max: 9804,
          },
          40000: {
            min: 8506,
            max: 10891,
          },
          45000: {
            min: 9336,
            max: 11942,
          },
          50000: {
            min: 10157,
            max: 12991,
          },
          75000: {
            min: 13825,
            max: 17645,
          },
          100000: {
            min: 17184,
            max: 21839,
          },
          150000: {
            min: 23216,
            max: 29252,
          },
          200000: {
            min: 29057,
            max: 36110,
          },
          250000: {
            min: 35152,
            max: 43175,
          },
          300000: {
            min: 41263,
            max: 50245,
          },
          350000: {
            min: 47493,
            max: 57474,
          },
          400000: {
            min: 53700,
            max: 64757,
          },
          450000: {
            min: 59961,
            max: 72030,
          },
          500000: {
            min: 66254,
            max: 79301,
          },
          750000: {
            min: 96686,
            max: 113598,
          },
          1000000: {
            min: 125694,
            max: 144936,
          },
          1500000: {
            min: 180748,
            max: 200873,
          },
          2000000: {
            min: 233881,
            max: 254373,
          },
          2500000: {
            min: 285744,
            max: 308367,
          },
          3000000: {
            min: 335147,
            max: 359125,
          },
          3500000: {
            min: 380361,
            max: 405518,
          },
          3750000: {
            min: 401625,
            max: 427295,
          },
          3834689: {
            min: 408667,
            max: 434499,
          },
        },
        II: {
          5113: {
            min: 2109,
            max: 2593,
          },
          7500: {
            min: 2886,
            max: 3538,
          },
          10000: {
            min: 3618,
            max: 4421,
          },
          15000: {
            min: 4981,
            max: 6053,
          },
          20000: {
            min: 6262,
            max: 7605,
          },
          25000: {
            min: 7489,
            max: 9100,
          },
          30000: {
            min: 8670,
            max: 10552,
          },
          35000: {
            min: 9804,
            max: 11932,
          },
          40000: {
            min: 10891,
            max: 13269,
          },
          45000: {
            min: 11942,
            max: 14541,
          },
          50000: {
            min: 12991,
            max: 15818,
          },
          75000: {
            min: 17645,
            max: 21470,
          },
          100000: {
            min: 21839,
            max: 26490,
          },
          150000: {
            min: 29252,
            max: 35290,
          },
          200000: {
            min: 36110,
            max: 43159,
          },
          250000: {
            min: 43175,
            max: 51203,
          },
          300000: {
            min: 50245,
            max: 59227,
          },
          350000: {
            min: 57474,
            max: 67455,
          },
          400000: {
            min: 64757,
            max: 75819,
          },
          450000: {
            min: 72030,
            max: 84097,
          },
          500000: {
            min: 79301,
            max: 92353,
          },
          750000: {
            min: 113598,
            max: 130516,
          },
          1000000: {
            min: 144936,
            max: 164174,
          },
          1500000: {
            min: 200873,
            max: 220993,
          },
          2000000: {
            min: 254373,
            max: 274869,
          },
          2500000: {
            min: 308367,
            max: 330998,
          },
          3000000: {
            min: 359125,
            max: 383098,
          },
          3500000: {
            min: 405518,
            max: 430680,
          },
          3750000: {
            min: 427295,
            max: 452971,
          },
          3834689: {
            min: 434499,
            max: 460336,
          },
        },
        III: {
          5113: {
            min: 2593,
            max: 3077,
          },
          7500: {
            min: 3538,
            max: 4190,
          },
          10000: {
            min: 4421,
            max: 5227,
          },
          15000: {
            min: 6053,
            max: 7132,
          },
          20000: {
            min: 7605,
            max: 8947,
          },
          25000: {
            min: 9100,
            max: 10707,
          },
          30000: {
            min: 10552,
            max: 12428,
          },
          35000: {
            min: 11932,
            max: 14062,
          },
          40000: {
            min: 13269,
            max: 15653,
          },
          45000: {
            min: 14541,
            max: 17147,
          },
          50000: {
            min: 15818,
            max: 18652,
          },
          75000: {
            min: 21470,
            max: 25290,
          },
          100000: {
            min: 26490,
            max: 31145,
          },
          150000: {
            min: 35290,
            max: 41328,
          },
          200000: {
            min: 43159,
            max: 50212,
          },
          250000: {
            min: 51203,
            max: 59226,
          },
          300000: {
            min: 59227,
            max: 68209,
          },
          350000: {
            min: 67455,
            max: 77437,
          },
          400000: {
            min: 75819,
            max: 86876,
          },
          450000: {
            min: 84097,
            max: 96166,
          },
          500000: {
            min: 92353,
            max: 105400,
          },
          750000: {
            min: 130516,
            max: 147428,
          },
          1000000: {
            min: 164174,
            max: 183415,
          },
          1500000: {
            min: 220993,
            max: 241119,
          },
          2000000: {
            min: 274869,
            max: 295361,
          },
          2500000: {
            min: 330998,
            max: 353621,
          },
          3000000: {
            min: 383098,
            max: 407076,
          },
          3500000: {
            min: 430680,
            max: 455838,
          },
          3750000: {
            min: 452971,
            max: 478641,
          },
          3834689: {
            min: 460336,
            max: 486168,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Vorplanung',
          maxPercent: '11',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '15',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '6',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '18',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '6',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '5',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung',
          maxPercent: '33',
        },
        {
          title: 'Objektbetreuung und Dokumentation',
          maxPercent: '3',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.1 - Umweltverträglichkeitsstudie',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          50: {
            min: 7581,
            max: 9258,
          },
          100: {
            min: 10107,
            max: 12340,
          },
          250: {
            min: 16423,
            max: 20298,
          },
          500: {
            min: 25421,
            max: 31811,
          },
          750: {
            min: 33239,
            max: 41956,
          },
          1000: {
            min: 40422,
            max: 51411,
          },
          1250: {
            min: 46973,
            max: 60000,
          },
          1500: {
            min: 53053,
            max: 68210,
          },
          1750: {
            min: 59684,
            max: 76636,
          },
          2000: {
            min: 65685,
            max: 84212,
          },
          2500: {
            min: 76580,
            max: 98160,
          },
          3000: {
            min: 87159,
            max: 110842,
          },
          3500: {
            min: 96158,
            max: 121944,
          },
          4000: {
            min: 104841,
            max: 132208,
          },
          4500: {
            min: 112265,
            max: 141635,
          },
          5000: {
            min: 120003,
            max: 151055,
          },
          5500: {
            min: 128531,
            max: 160369,
          },
          6000: {
            min: 136421,
            max: 169266,
          },
          6500: {
            min: 143688,
            max: 177900,
          },
          7000: {
            min: 150318,
            max: 186319,
          },
          7500: {
            min: 158687,
            max: 196583,
          },
          8000: {
            min: 166741,
            max: 206318,
          },
          8500: {
            min: 174474,
            max: 216526,
          },
          9000: {
            min: 181898,
            max: 226425,
          },
          9500: {
            min: 189002,
            max: 236503,
          },
          10000: {
            min: 195790,
            max: 246318,
          },
        },
        II: {
          50: {
            min: 9258,
            max: 10927,
          },
          100: {
            min: 12340,
            max: 14566,
          },
          250: {
            min: 20298,
            max: 24167,
          },
          500: {
            min: 31811,
            max: 38200,
          },
          750: {
            min: 41956,
            max: 50680,
          },
          1000: {
            min: 51411,
            max: 62401,
          },
          1250: {
            min: 60000,
            max: 73025,
          },
          1500: {
            min: 68210,
            max: 83368,
          },
          1750: {
            min: 76636,
            max: 93581,
          },
          2000: {
            min: 84212,
            max: 102738,
          },
          2500: {
            min: 98160,
            max: 119739,
          },
          3000: {
            min: 110842,
            max: 134526,
          },
          3500: {
            min: 121944,
            max: 147737,
          },
          4000: {
            min: 132208,
            max: 159581,
          },
          4500: {
            min: 141635,
            max: 171004,
          },
          5000: {
            min: 151055,
            max: 182112,
          },
          5500: {
            min: 160369,
            max: 192213,
          },
          6000: {
            min: 169266,
            max: 202106,
          },
          6500: {
            min: 177900,
            max: 212106,
          },
          7000: {
            min: 186319,
            max: 222320,
          },
          7500: {
            min: 196583,
            max: 234479,
          },
          8000: {
            min: 206318,
            max: 245896,
          },
          8500: {
            min: 216526,
            max: 258585,
          },
          9000: {
            min: 226425,
            max: 270952,
          },
          9500: {
            min: 236503,
            max: 284000,
          },
          10000: {
            min: 246318,
            max: 296846,
          },
        },
        III: {
          50: {
            min: 10927,
            max: 12604,
          },
          100: {
            min: 14566,
            max: 16799,
          },
          250: {
            min: 24167,
            max: 28042,
          },
          500: {
            min: 38200,
            max: 44589,
          },
          750: {
            min: 50680,
            max: 59398,
          },
          1000: {
            min: 62401,
            max: 73390,
          },
          1250: {
            min: 73025,
            max: 86051,
          },
          1500: {
            min: 83368,
            max: 98525,
          },
          1750: {
            min: 93581,
            max: 110532,
          },
          2000: {
            min: 102738,
            max: 121264,
          },
          2500: {
            min: 119739,
            max: 141319,
          },
          3000: {
            min: 134526,
            max: 158209,
          },
          3500: {
            min: 147737,
            max: 173524,
          },
          4000: {
            min: 159581,
            max: 186948,
          },
          4500: {
            min: 171004,
            max: 200374,
          },
          5000: {
            min: 182112,
            max: 213164,
          },
          5500: {
            min: 192213,
            max: 224051,
          },
          6000: {
            min: 202106,
            max: 234951,
          },
          6500: {
            min: 212106,
            max: 246318,
          },
          7000: {
            min: 222320,
            max: 258320,
          },
          7500: {
            min: 234479,
            max: 272375,
          },
          8000: {
            min: 245896,
            max: 285474,
          },
          8500: {
            min: 258585,
            max: 300637,
          },
          9000: {
            min: 270952,
            max: 315479,
          },
          9500: {
            min: 284000,
            max: 331503,
          },
          10000: {
            min: 296846,
            max: 347373,
          },
        },
      },
      phases: [
        {
          title:
            'Klären der Aufgabenstellung und Ermitteln des Leistungsumfangs',
          maxPercent: '3',
        },
        {
          title:
            'Ermitteln und Bewerten der Planungsgrundlagen Bestandsaufnahme, Bestandsbewertung und zusammenfassende Darstellung',
          maxPercent: '30',
        },
        {
          title: 'Konfliktanalyse und Alternativen',
          maxPercent: '20',
        },
        {
          title: 'Vorläufige Fassung der Studie',
          maxPercent: '40',
        },
        {
          title: 'Endgültige Fassung der Studie',
          maxPercent: '7',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.2.2 - Wärmeschutz',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          255646: {
            min: 596,
            max: 686,
          },
          500000: {
            min: 768,
            max: 912,
          },
          2500000: {
            min: 2083,
            max: 2416,
          },
          5000000: {
            min: 3136,
            max: 3636,
          },
          25000000: {
            min: 12989,
            max: 14436,
          },
          25564594: {
            min: 13267,
            max: 14741,
          },
        },
        II: {
          255646: {
            min: 686,
            max: 810,
          },
          500000: {
            min: 912,
            max: 1111,
          },
          2500000: {
            min: 2416,
            max: 2853,
          },
          5000000: {
            min: 3636,
            max: 4300,
          },
          25000000: {
            min: 14436,
            max: 16369,
          },
          25564594: {
            min: 14741,
            max: 16709,
          },
        },
        III: {
          255646: {
            min: 810,
            max: 990,
          },
          500000: {
            min: 1111,
            max: 1398,
          },
          2500000: {
            min: 2853,
            max: 3512,
          },
          5000000: {
            min: 4300,
            max: 5297,
          },
          25000000: {
            min: 16369,
            max: 19268,
          },
          25564594: {
            min: 16709,
            max: 19663,
          },
        },
        IV: {
          255646: {
            min: 990,
            max: 1113,
          },
          500000: {
            min: 1398,
            max: 1597,
          },
          2500000: {
            min: 3512,
            max: 3949,
          },
          5000000: {
            min: 5297,
            max: 5962,
          },
          25000000: {
            min: 19268,
            max: 21200,
          },
          25564594: {
            min: 19663,
            max: 21630,
          },
        },
        V: {
          255646: {
            min: 1113,
            max: 1203,
          },
          500000: {
            min: 1597,
            max: 1741,
          },
          2500000: {
            min: 3949,
            max: 4281,
          },
          5000000: {
            min: 5962,
            max: 6460,
          },
          25000000: {
            min: 21200,
            max: 22648,
          },
          25564594: {
            min: 21630,
            max: 23104,
          },
        },
      },
      phases: [
        {
          title: 'Erarbeiten des Planungskonzepts für den Wärmeschutz',
          maxPercent: '20',
        },
        {
          title: 'Erarbeiten des Entwurfs',
          maxPercent: '40',
        },
        {
          title: 'Nachweises des Wärmeschutzes',
          maxPercent: '25',
        },
        {
          title: 'Abstimmen des geplanten Wärmeschutzes',
          maxPercent: '15',
        },
        {
          title: 'Mitwirken bei der Ausführungsüberwachung',
          maxPercent: '0',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.3.3 - Bauakustik',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          255646: {
            min: 1766,
            max: 2025,
          },
          300000: {
            min: 1942,
            max: 2230,
          },
          350000: {
            min: 2135,
            max: 2451,
          },
          400000: {
            min: 2323,
            max: 2662,
          },
          450000: {
            min: 2506,
            max: 2871,
          },
          500000: {
            min: 2670,
            max: 3062,
          },
          750000: {
            min: 3462,
            max: 3971,
          },
          1000000: {
            min: 4171,
            max: 4782,
          },
          1500000: {
            min: 5433,
            max: 6229,
          },
          2000000: {
            min: 6564,
            max: 7527,
          },
          2500000: {
            min: 7605,
            max: 8724,
          },
          3000000: {
            min: 8581,
            max: 9844,
          },
          3500000: {
            min: 9501,
            max: 10898,
          },
          4000000: {
            min: 10382,
            max: 11905,
          },
          4500000: {
            min: 11224,
            max: 12876,
          },
          5000000: {
            min: 12034,
            max: 13803,
          },
          7500000: {
            min: 15740,
            max: 18053,
          },
          10000000: {
            min: 19061,
            max: 21864,
          },
          15000000: {
            min: 24957,
            max: 28628,
          },
          20000000: {
            min: 30230,
            max: 34676,
          },
          25000000: {
            min: 35080,
            max: 40237,
          },
          25564594: {
            min: 35624,
            max: 40860,
          },
        },
        II: {
          255646: {
            min: 2025,
            max: 2329,
          },
          300000: {
            min: 2230,
            max: 2567,
          },
          350000: {
            min: 2451,
            max: 2823,
          },
          400000: {
            min: 2662,
            max: 3071,
          },
          450000: {
            min: 2871,
            max: 3310,
          },
          500000: {
            min: 3062,
            max: 3533,
          },
          750000: {
            min: 3971,
            max: 4580,
          },
          1000000: {
            min: 4782,
            max: 5512,
          },
          1500000: {
            min: 6229,
            max: 7187,
          },
          2000000: {
            min: 7527,
            max: 8685,
          },
          2500000: {
            min: 8724,
            max: 10065,
          },
          3000000: {
            min: 9844,
            max: 11351,
          },
          3500000: {
            min: 10898,
            max: 12570,
          },
          4000000: {
            min: 11905,
            max: 13734,
          },
          4500000: {
            min: 12876,
            max: 14848,
          },
          5000000: {
            min: 13803,
            max: 15923,
          },
          7500000: {
            min: 18053,
            max: 20822,
          },
          10000000: {
            min: 21864,
            max: 25213,
          },
          15000000: {
            min: 28628,
            max: 33017,
          },
          20000000: {
            min: 34676,
            max: 39993,
          },
          25000000: {
            min: 40237,
            max: 46407,
          },
          25564594: {
            min: 40860,
            max: 47125,
          },
        },
        III: {
          255646: {
            min: 2329,
            max: 2683,
          },
          300000: {
            min: 2567,
            max: 2961,
          },
          350000: {
            min: 2823,
            max: 3255,
          },
          400000: {
            min: 3071,
            max: 3538,
          },
          450000: {
            min: 3310,
            max: 3809,
          },
          500000: {
            min: 3533,
            max: 4074,
          },
          750000: {
            min: 4580,
            max: 5279,
          },
          1000000: {
            min: 5512,
            max: 6355,
          },
          1500000: {
            min: 7187,
            max: 8284,
          },
          2000000: {
            min: 8685,
            max: 10009,
          },
          2500000: {
            min: 10065,
            max: 11604,
          },
          3000000: {
            min: 11351,
            max: 13086,
          },
          3500000: {
            min: 12570,
            max: 14487,
          },
          4000000: {
            min: 13734,
            max: 15828,
          },
          4500000: {
            min: 14848,
            max: 17114,
          },
          5000000: {
            min: 15923,
            max: 18355,
          },
          7500000: {
            min: 20822,
            max: 24000,
          },
          10000000: {
            min: 25213,
            max: 29068,
          },
          15000000: {
            min: 33017,
            max: 38060,
          },
          20000000: {
            min: 39993,
            max: 46107,
          },
          25000000: {
            min: 46407,
            max: 53496,
          },
          25564594: {
            min: 47125,
            max: 54325,
          },
        },
      },
      phases: [
        {
          title: 'Erarbeiten des Planungskonzepts',
          maxPercent: '10',
        },
        {
          title: 'Erarbeiten des Entwurfs',
          maxPercent: '35',
        },
        {
          title: 'Mitwirken bei der Ausführungsplanung',
          maxPercent: '30',
        },
        {
          title:
            'Mitwirken bei der Vorbereitung der Vergabe und bei der Vergabe',
          maxPercent: '5',
        },
        {
          title: 'Mitwirken bei der Überwachung',
          maxPercent: '20',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.3.6 - Raumakustik',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          51129: {
            min: 1084,
            max: 1411,
          },
          100000: {
            min: 1245,
            max: 1621,
          },
          150000: {
            min: 1405,
            max: 1827,
          },
          200000: {
            min: 1556,
            max: 2022,
          },
          250000: {
            min: 1706,
            max: 2217,
          },
          300000: {
            min: 1861,
            max: 2417,
          },
          350000: {
            min: 1998,
            max: 2600,
          },
          400000: {
            min: 2142,
            max: 2784,
          },
          450000: {
            min: 2287,
            max: 2969,
          },
          500000: {
            min: 2420,
            max: 3146,
          },
          750000: {
            min: 3094,
            max: 4021,
          },
          1000000: {
            min: 3731,
            max: 4849,
          },
          1500000: {
            min: 4958,
            max: 6442,
          },
          2000000: {
            min: 6132,
            max: 7971,
          },
          2500000: {
            min: 7270,
            max: 9451,
          },
          3000000: {
            min: 8387,
            max: 10904,
          },
          3500000: {
            min: 9485,
            max: 12328,
          },
          4000000: {
            min: 10568,
            max: 13735,
          },
          4500000: {
            min: 11635,
            max: 15124,
          },
          5000000: {
            min: 12692,
            max: 16501,
          },
          7500000: {
            min: 17858,
            max: 23213,
          },
          7669378: {
            min: 18207,
            max: 23668,
          },
        },
        II: {
          51129: {
            min: 1411,
            max: 1738,
          },
          100000: {
            min: 1621,
            max: 1993,
          },
          150000: {
            min: 1827,
            max: 2248,
          },
          200000: {
            min: 2022,
            max: 2493,
          },
          250000: {
            min: 2217,
            max: 2734,
          },
          300000: {
            min: 2417,
            max: 2974,
          },
          350000: {
            min: 2600,
            max: 3201,
          },
          400000: {
            min: 2784,
            max: 3426,
          },
          450000: {
            min: 2969,
            max: 3655,
          },
          500000: {
            min: 3146,
            max: 3873,
          },
          750000: {
            min: 4021,
            max: 4943,
          },
          1000000: {
            min: 4849,
            max: 5967,
          },
          1500000: {
            min: 6442,
            max: 7926,
          },
          2000000: {
            min: 7971,
            max: 9806,
          },
          2500000: {
            min: 9451,
            max: 11631,
          },
          3000000: {
            min: 10904,
            max: 13420,
          },
          3500000: {
            min: 12328,
            max: 15175,
          },
          4000000: {
            min: 13735,
            max: 16904,
          },
          4500000: {
            min: 15124,
            max: 18612,
          },
          5000000: {
            min: 16501,
            max: 20305,
          },
          7500000: {
            min: 23213,
            max: 28569,
          },
          7669378: {
            min: 23668,
            max: 29128,
          },
        },
        III: {
          51129: {
            min: 1738,
            max: 2061,
          },
          100000: {
            min: 1993,
            max: 2368,
          },
          150000: {
            min: 2248,
            max: 2664,
          },
          200000: {
            min: 2493,
            max: 2959,
          },
          250000: {
            min: 2734,
            max: 3245,
          },
          300000: {
            min: 2974,
            max: 3530,
          },
          350000: {
            min: 3201,
            max: 3802,
          },
          400000: {
            min: 3426,
            max: 4072,
          },
          450000: {
            min: 3655,
            max: 4338,
          },
          500000: {
            min: 3873,
            max: 4603,
          },
          750000: {
            min: 4943,
            max: 5871,
          },
          1000000: {
            min: 5967,
            max: 7089,
          },
          1500000: {
            min: 7926,
            max: 9414,
          },
          2000000: {
            min: 9806,
            max: 11646,
          },
          2500000: {
            min: 11631,
            max: 13812,
          },
          3000000: {
            min: 13420,
            max: 15932,
          },
          3500000: {
            min: 15175,
            max: 18016,
          },
          4000000: {
            min: 16904,
            max: 20075,
          },
          4500000: {
            min: 18612,
            max: 22106,
          },
          5000000: {
            min: 20305,
            max: 24115,
          },
          7500000: {
            min: 28569,
            max: 33925,
          },
          7669378: {
            min: 29128,
            max: 34589,
          },
        },
        IV: {
          51129: {
            min: 2061,
            max: 2388,
          },
          100000: {
            min: 2368,
            max: 2740,
          },
          150000: {
            min: 2664,
            max: 3085,
          },
          200000: {
            min: 2959,
            max: 3430,
          },
          250000: {
            min: 3245,
            max: 3762,
          },
          300000: {
            min: 3530,
            max: 4087,
          },
          350000: {
            min: 3802,
            max: 4404,
          },
          400000: {
            min: 4072,
            max: 4714,
          },
          450000: {
            min: 4338,
            max: 5024,
          },
          500000: {
            min: 4603,
            max: 5330,
          },
          750000: {
            min: 5871,
            max: 6793,
          },
          1000000: {
            min: 7089,
            max: 8207,
          },
          1500000: {
            min: 9414,
            max: 10898,
          },
          2000000: {
            min: 11646,
            max: 13480,
          },
          2500000: {
            min: 13812,
            max: 15992,
          },
          3000000: {
            min: 15932,
            max: 18448,
          },
          3500000: {
            min: 18016,
            max: 20863,
          },
          4000000: {
            min: 20075,
            max: 23244,
          },
          4500000: {
            min: 22106,
            max: 25594,
          },
          5000000: {
            min: 24115,
            max: 27919,
          },
          7500000: {
            min: 33925,
            max: 39281,
          },
          7669378: {
            min: 34589,
            max: 40049,
          },
        },
        V: {
          51129: {
            min: 2388,
            max: 2715,
          },
          100000: {
            min: 2740,
            max: 3116,
          },
          150000: {
            min: 3085,
            max: 3507,
          },
          200000: {
            min: 3430,
            max: 3897,
          },
          250000: {
            min: 3762,
            max: 4273,
          },
          300000: {
            min: 4087,
            max: 4644,
          },
          350000: {
            min: 4404,
            max: 5005,
          },
          400000: {
            min: 4714,
            max: 5356,
          },
          450000: {
            min: 5024,
            max: 5706,
          },
          500000: {
            min: 5330,
            max: 6056,
          },
          750000: {
            min: 6793,
            max: 7721,
          },
          1000000: {
            min: 8207,
            max: 9325,
          },
          1500000: {
            min: 10898,
            max: 12381,
          },
          2000000: {
            min: 13480,
            max: 15319,
          },
          2500000: {
            min: 15992,
            max: 18172,
          },
          3000000: {
            min: 18448,
            max: 20964,
          },
          3500000: {
            min: 20863,
            max: 23706,
          },
          4000000: {
            min: 23244,
            max: 26411,
          },
          4500000: {
            min: 25594,
            max: 29083,
          },
          5000000: {
            min: 27919,
            max: 31728,
          },
          7500000: {
            min: 39281,
            max: 44636,
          },
          7669378: {
            min: 40049,
            max: 45510,
          },
        },
      },
      phases: [
        {
          title: 'Erarbeiten des raumakustischen Planungskonzepts',
          maxPercent: '20',
        },
        {
          title: 'Erarbeiten des raumakustischen Entwurfs',
          maxPercent: '35',
        },
        {
          title: 'Mitwirken bei der Ausführungsplanung',
          maxPercent: '25',
        },
        {
          title:
            'Mitwirken bei der Vorbereitung der Vergabe und bei der Vergabe',
          maxPercent: '5',
        },
        {
          title: 'Mitwirken bei der Überwachung',
          maxPercent: '15',
        },
      ],
    },
    {
      label:
        'Anlage 1, Ziff. 1.4.3 - Baugrundbeurteilung und Gründungsberatung',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          51129: {
            min: 524,
            max: 945,
          },
          75000: {
            min: 644,
            max: 1140,
          },
          100000: {
            min: 750,
            max: 1307,
          },
          150000: {
            min: 922,
            max: 1584,
          },
          200000: {
            min: 1077,
            max: 1824,
          },
          250000: {
            min: 1207,
            max: 2025,
          },
          300000: {
            min: 1333,
            max: 2218,
          },
          350000: {
            min: 1445,
            max: 2387,
          },
          400000: {
            min: 1550,
            max: 2548,
          },
          450000: {
            min: 1646,
            max: 2693,
          },
          500000: {
            min: 1739,
            max: 2831,
          },
          750000: {
            min: 2149,
            max: 3445,
          },
          1000000: {
            min: 2510,
            max: 3969,
          },
          1500000: {
            min: 3099,
            max: 4825,
          },
          2000000: {
            min: 3610,
            max: 5554,
          },
          2500000: {
            min: 4056,
            max: 6189,
          },
          3000000: {
            min: 4462,
            max: 6763,
          },
          3500000: {
            min: 4840,
            max: 7291,
          },
          4000000: {
            min: 5191,
            max: 7780,
          },
          4500000: {
            min: 5519,
            max: 8238,
          },
          5000000: {
            min: 5834,
            max: 8676,
          },
          7500000: {
            min: 7224,
            max: 10570,
          },
          10000000: {
            min: 8404,
            max: 12169,
          },
          15000000: {
            min: 10395,
            max: 14832,
          },
          20000000: {
            min: 12098,
            max: 17083,
          },
          25000000: {
            min: 13606,
            max: 19060,
          },
          25564594: {
            min: 13774,
            max: 19280,
          },
        },
        II: {
          51129: {
            min: 945,
            max: 1361,
          },
          75000: {
            min: 1140,
            max: 1629,
          },
          100000: {
            min: 1307,
            max: 1863,
          },
          150000: {
            min: 1584,
            max: 2241,
          },
          200000: {
            min: 1824,
            max: 2570,
          },
          250000: {
            min: 2025,
            max: 2844,
          },
          300000: {
            min: 2218,
            max: 3103,
          },
          350000: {
            min: 2387,
            max: 3329,
          },
          400000: {
            min: 2548,
            max: 3544,
          },
          450000: {
            min: 2693,
            max: 3740,
          },
          500000: {
            min: 2831,
            max: 3928,
          },
          750000: {
            min: 3445,
            max: 4743,
          },
          1000000: {
            min: 3969,
            max: 5429,
          },
          1500000: {
            min: 4825,
            max: 6551,
          },
          2000000: {
            min: 5554,
            max: 7502,
          },
          2500000: {
            min: 6189,
            max: 8323,
          },
          3000000: {
            min: 6763,
            max: 9063,
          },
          3500000: {
            min: 7291,
            max: 9742,
          },
          4000000: {
            min: 7780,
            max: 10366,
          },
          4500000: {
            min: 8238,
            max: 10956,
          },
          5000000: {
            min: 8676,
            max: 11513,
          },
          7500000: {
            min: 10570,
            max: 13916,
          },
          10000000: {
            min: 12169,
            max: 15934,
          },
          15000000: {
            min: 14832,
            max: 19270,
          },
          20000000: {
            min: 17083,
            max: 22067,
          },
          25000000: {
            min: 19060,
            max: 24518,
          },
          25564594: {
            min: 19280,
            max: 24792,
          },
        },
        III: {
          51129: {
            min: 1361,
            max: 1783,
          },
          75000: {
            min: 1629,
            max: 2124,
          },
          100000: {
            min: 1863,
            max: 2416,
          },
          150000: {
            min: 2241,
            max: 2903,
          },
          200000: {
            min: 2570,
            max: 3310,
          },
          250000: {
            min: 2844,
            max: 3666,
          },
          300000: {
            min: 3103,
            max: 3984,
          },
          350000: {
            min: 3329,
            max: 4275,
          },
          400000: {
            min: 3544,
            max: 4538,
          },
          450000: {
            min: 3740,
            max: 4786,
          },
          500000: {
            min: 3928,
            max: 5020,
          },
          750000: {
            min: 4743,
            max: 6035,
          },
          1000000: {
            min: 5429,
            max: 6887,
          },
          1500000: {
            min: 6551,
            max: 8281,
          },
          2000000: {
            min: 7502,
            max: 9446,
          },
          2500000: {
            min: 8323,
            max: 10461,
          },
          3000000: {
            min: 9063,
            max: 11364,
          },
          3500000: {
            min: 9742,
            max: 12194,
          },
          4000000: {
            min: 10366,
            max: 12957,
          },
          4500000: {
            min: 10956,
            max: 13670,
          },
          5000000: {
            min: 11513,
            max: 14352,
          },
          7500000: {
            min: 13916,
            max: 17262,
          },
          10000000: {
            min: 15934,
            max: 19698,
          },
          15000000: {
            min: 19270,
            max: 23707,
          },
          20000000: {
            min: 22067,
            max: 27058,
          },
          25000000: {
            min: 24518,
            max: 29973,
          },
          25564594: {
            min: 24792,
            max: 30297,
          },
        },
        IV: {
          51129: {
            min: 1783,
            max: 2199,
          },
          75000: {
            min: 2124,
            max: 2614,
          },
          100000: {
            min: 2416,
            max: 2971,
          },
          150000: {
            min: 2903,
            max: 3560,
          },
          200000: {
            min: 3310,
            max: 4056,
          },
          250000: {
            min: 3666,
            max: 4486,
          },
          300000: {
            min: 3984,
            max: 4870,
          },
          350000: {
            min: 4275,
            max: 5216,
          },
          400000: {
            min: 4538,
            max: 5534,
          },
          450000: {
            min: 4786,
            max: 5833,
          },
          500000: {
            min: 5020,
            max: 6118,
          },
          750000: {
            min: 6035,
            max: 7332,
          },
          1000000: {
            min: 6887,
            max: 8346,
          },
          1500000: {
            min: 8281,
            max: 10007,
          },
          2000000: {
            min: 9446,
            max: 11395,
          },
          2500000: {
            min: 10461,
            max: 12594,
          },
          3000000: {
            min: 11364,
            max: 13664,
          },
          3500000: {
            min: 12194,
            max: 14644,
          },
          4000000: {
            min: 12957,
            max: 15543,
          },
          4500000: {
            min: 13670,
            max: 16388,
          },
          5000000: {
            min: 14352,
            max: 17189,
          },
          7500000: {
            min: 17262,
            max: 20607,
          },
          10000000: {
            min: 19698,
            max: 23463,
          },
          15000000: {
            min: 23707,
            max: 28145,
          },
          20000000: {
            min: 27058,
            max: 32043,
          },
          25000000: {
            min: 29973,
            max: 35432,
          },
          25564594: {
            min: 30297,
            max: 35809,
          },
        },
        V: {
          51129: {
            min: 2199,
            max: 2621,
          },
          75000: {
            min: 2614,
            max: 3110,
          },
          100000: {
            min: 2971,
            max: 3529,
          },
          150000: {
            min: 3560,
            max: 4222,
          },
          200000: {
            min: 4056,
            max: 4802,
          },
          250000: {
            min: 4486,
            max: 5304,
          },
          300000: {
            min: 4870,
            max: 5755,
          },
          350000: {
            min: 5216,
            max: 6158,
          },
          400000: {
            min: 5534,
            max: 6531,
          },
          450000: {
            min: 5833,
            max: 6882,
          },
          500000: {
            min: 6118,
            max: 7211,
          },
          750000: {
            min: 7332,
            max: 8627,
          },
          1000000: {
            min: 8346,
            max: 9805,
          },
          1500000: {
            min: 10007,
            max: 11733,
          },
          2000000: {
            min: 11395,
            max: 13339,
          },
          2500000: {
            min: 12594,
            max: 14727,
          },
          3000000: {
            min: 13664,
            max: 15964,
          },
          3500000: {
            min: 14644,
            max: 17095,
          },
          4000000: {
            min: 15543,
            max: 18134,
          },
          4500000: {
            min: 16388,
            max: 19107,
          },
          5000000: {
            min: 17189,
            max: 20030,
          },
          7500000: {
            min: 20607,
            max: 23954,
          },
          10000000: {
            min: 23463,
            max: 27227,
          },
          15000000: {
            min: 28145,
            max: 32582,
          },
          20000000: {
            min: 32043,
            max: 37027,
          },
          25000000: {
            min: 35432,
            max: 40886,
          },
          25564594: {
            min: 35809,
            max: 41316,
          },
        },
      },
      phases: [
        {
          title: 'Klären der Aufgabenstellung',
          maxPercent: '15',
        },
        {
          title: 'Auswerten und Darstellen der Baugrunderkundungen',
          maxPercent: '35',
        },
        {
          title: 'Vorschlag für die Gründung',
          maxPercent: '50',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.5.4. Entwurfsvermessung',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          51129: {
            min: 2250,
            max: 2643,
          },
          100000: {
            min: 3325,
            max: 3826,
          },
          150000: {
            min: 4320,
            max: 4931,
          },
          200000: {
            min: 5156,
            max: 5826,
          },
          250000: {
            min: 5881,
            max: 6656,
          },
          300000: {
            min: 6547,
            max: 7383,
          },
          350000: {
            min: 7207,
            max: 8098,
          },
          400000: {
            min: 7867,
            max: 8859,
          },
          450000: {
            min: 8527,
            max: 9584,
          },
          500000: {
            min: 9187,
            max: 10299,
          },
          750000: {
            min: 11332,
            max: 12667,
          },
          1000000: {
            min: 13525,
            max: 14977,
          },
          1500000: {
            min: 17714,
            max: 19597,
          },
          2000000: {
            min: 21894,
            max: 24217,
          },
          2500000: {
            min: 26074,
            max: 28837,
          },
          3000000: {
            min: 30254,
            max: 33457,
          },
          3500000: {
            min: 34434,
            max: 38077,
          },
          4000000: {
            min: 38614,
            max: 42697,
          },
          4500000: {
            min: 42794,
            max: 47317,
          },
          5000000: {
            min: 46974,
            max: 51937,
          },
          7500000: {
            min: 67874,
            max: 75037,
          },
          10000000: {
            min: 88672,
            max: 98137,
          },
          10225838: {
            min: 90550,
            max: 100223,
          },
        },
        II: {
          51129: {
            min: 2643,
            max: 3037,
          },
          100000: {
            min: 3826,
            max: 4327,
          },
          150000: {
            min: 4931,
            max: 5542,
          },
          200000: {
            min: 5826,
            max: 6547,
          },
          250000: {
            min: 6656,
            max: 7437,
          },
          300000: {
            min: 7383,
            max: 8219,
          },
          350000: {
            min: 8098,
            max: 9037,
          },
          400000: {
            min: 8859,
            max: 9815,
          },
          450000: {
            min: 9584,
            max: 10630,
          },
          500000: {
            min: 10299,
            max: 11413,
          },
          750000: {
            min: 12667,
            max: 14002,
          },
          1000000: {
            min: 14977,
            max: 16532,
          },
          1500000: {
            min: 19597,
            max: 21592,
          },
          2000000: {
            min: 24217,
            max: 26652,
          },
          2500000: {
            min: 28837,
            max: 31712,
          },
          3000000: {
            min: 33457,
            max: 36772,
          },
          3500000: {
            min: 38077,
            max: 41832,
          },
          4000000: {
            min: 42697,
            max: 46892,
          },
          4500000: {
            min: 47317,
            max: 51952,
          },
          5000000: {
            min: 51937,
            max: 57012,
          },
          7500000: {
            min: 75037,
            max: 82312,
          },
          10000000: {
            min: 98137,
            max: 107612,
          },
          10225838: {
            min: 100223,
            max: 109897,
          },
        },
        III: {
          51129: {
            min: 3037,
            max: 3431,
          },
          100000: {
            min: 4327,
            max: 4829,
          },
          150000: {
            min: 5542,
            max: 6153,
          },
          200000: {
            min: 6547,
            max: 7217,
          },
          250000: {
            min: 7437,
            max: 8212,
          },
          300000: {
            min: 8219,
            max: 9055,
          },
          350000: {
            min: 9037,
            max: 9929,
          },
          400000: {
            min: 9815,
            max: 10809,
          },
          450000: {
            min: 10630,
            max: 11644,
          },
          500000: {
            min: 11413,
            max: 12513,
          },
          750000: {
            min: 14002,
            max: 15336,
          },
          1000000: {
            min: 16532,
            max: 18086,
          },
          1500000: {
            min: 21592,
            max: 23586,
          },
          2000000: {
            min: 26652,
            max: 29086,
          },
          2500000: {
            min: 31712,
            max: 34586,
          },
          3000000: {
            min: 36772,
            max: 40086,
          },
          3500000: {
            min: 41832,
            max: 45586,
          },
          4000000: {
            min: 46892,
            max: 51086,
          },
          4500000: {
            min: 51952,
            max: 56586,
          },
          5000000: {
            min: 57012,
            max: 62086,
          },
          7500000: {
            min: 82312,
            max: 89586,
          },
          10000000: {
            min: 107612,
            max: 117086,
          },
          10225838: {
            min: 109897,
            max: 119571,
          },
        },
        IV: {
          51129: {
            min: 3431,
            max: 3825,
          },
          100000: {
            min: 4829,
            max: 5330,
          },
          150000: {
            min: 6153,
            max: 6765,
          },
          200000: {
            min: 7217,
            max: 7939,
          },
          250000: {
            min: 8212,
            max: 8994,
          },
          300000: {
            min: 9055,
            max: 9892,
          },
          350000: {
            min: 9929,
            max: 10867,
          },
          400000: {
            min: 10809,
            max: 11765,
          },
          450000: {
            min: 11644,
            max: 12690,
          },
          500000: {
            min: 12513,
            max: 13625,
          },
          750000: {
            min: 15336,
            max: 16672,
          },
          1000000: {
            min: 18086,
            max: 19642,
          },
          1500000: {
            min: 23586,
            max: 25582,
          },
          2000000: {
            min: 29086,
            max: 31522,
          },
          2500000: {
            min: 34586,
            max: 37462,
          },
          3000000: {
            min: 40086,
            max: 43402,
          },
          3500000: {
            min: 45586,
            max: 49342,
          },
          4000000: {
            min: 51086,
            max: 55282,
          },
          4500000: {
            min: 56586,
            max: 61222,
          },
          5000000: {
            min: 62086,
            max: 67162,
          },
          7500000: {
            min: 89586,
            max: 96862,
          },
          10000000: {
            min: 117086,
            max: 126562,
          },
          10225838: {
            min: 119571,
            max: 129245,
          },
        },
        V: {
          51129: {
            min: 3825,
            max: 4219,
          },
          100000: {
            min: 5330,
            max: 5831,
          },
          150000: {
            min: 6765,
            max: 7376,
          },
          200000: {
            min: 7939,
            max: 8609,
          },
          250000: {
            min: 8994,
            max: 9768,
          },
          300000: {
            min: 9892,
            max: 10728,
          },
          350000: {
            min: 10867,
            max: 11758,
          },
          400000: {
            min: 11765,
            max: 12757,
          },
          450000: {
            min: 12690,
            max: 13747,
          },
          500000: {
            min: 13625,
            max: 14737,
          },
          750000: {
            min: 16672,
            max: 18006,
          },
          1000000: {
            min: 19642,
            max: 21196,
          },
          1500000: {
            min: 25582,
            max: 27576,
          },
          2000000: {
            min: 31522,
            max: 33956,
          },
          2500000: {
            min: 37462,
            max: 40336,
          },
          3000000: {
            min: 43402,
            max: 46716,
          },
          3500000: {
            min: 49342,
            max: 53096,
          },
          4000000: {
            min: 55282,
            max: 59476,
          },
          4500000: {
            min: 61222,
            max: 65856,
          },
          5000000: {
            min: 67162,
            max: 72236,
          },
          7500000: {
            min: 96862,
            max: 104136,
          },
          10000000: {
            min: 126562,
            max: 136036,
          },
          10225838: {
            min: 129245,
            max: 138918,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Geodätischer Raumbezug',
          maxPercent: '15',
        },
        {
          title: 'Vermessungstechnische Lage- und Höhenpläne',
          maxPercent: '52',
        },
        {
          title: 'Absteckungsunterlagen',
          maxPercent: '15',
        },
        {
          title: 'Absteckung für Entwurf',
          maxPercent: '5',
        },
        {
          title: 'Geländeschnitte',
          maxPercent: '10',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.5.7. Bauvermessung',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          51129: {
            min: 2250,
            max: 2643,
          },
          100000: {
            min: 3325,
            max: 3826,
          },
          150000: {
            min: 4320,
            max: 4931,
          },
          200000: {
            min: 5156,
            max: 5826,
          },
          250000: {
            min: 5881,
            max: 6656,
          },
          300000: {
            min: 6547,
            max: 7383,
          },
          350000: {
            min: 7207,
            max: 8098,
          },
          400000: {
            min: 7867,
            max: 8859,
          },
          450000: {
            min: 8527,
            max: 9584,
          },
          500000: {
            min: 9187,
            max: 10299,
          },
          750000: {
            min: 11332,
            max: 12667,
          },
          1000000: {
            min: 13525,
            max: 14977,
          },
          1500000: {
            min: 17714,
            max: 19597,
          },
          2000000: {
            min: 21894,
            max: 24217,
          },
          2500000: {
            min: 26074,
            max: 28837,
          },
          3000000: {
            min: 30254,
            max: 33457,
          },
          3500000: {
            min: 34434,
            max: 38077,
          },
          4000000: {
            min: 38614,
            max: 42697,
          },
          4500000: {
            min: 42794,
            max: 47317,
          },
          5000000: {
            min: 46974,
            max: 51937,
          },
          7500000: {
            min: 67874,
            max: 75037,
          },
          10000000: {
            min: 88672,
            max: 98137,
          },
          10225838: {
            min: 90550,
            max: 100223,
          },
        },
        II: {
          51129: {
            min: 2643,
            max: 3037,
          },
          100000: {
            min: 3826,
            max: 4327,
          },
          150000: {
            min: 4931,
            max: 5542,
          },
          200000: {
            min: 5826,
            max: 6547,
          },
          250000: {
            min: 6656,
            max: 7437,
          },
          300000: {
            min: 7383,
            max: 8219,
          },
          350000: {
            min: 8098,
            max: 9037,
          },
          400000: {
            min: 8859,
            max: 9815,
          },
          450000: {
            min: 9584,
            max: 10630,
          },
          500000: {
            min: 10299,
            max: 11413,
          },
          750000: {
            min: 12667,
            max: 14002,
          },
          1000000: {
            min: 14977,
            max: 16532,
          },
          1500000: {
            min: 19597,
            max: 21592,
          },
          2000000: {
            min: 24217,
            max: 26652,
          },
          2500000: {
            min: 28837,
            max: 31712,
          },
          3000000: {
            min: 33457,
            max: 36772,
          },
          3500000: {
            min: 38077,
            max: 41832,
          },
          4000000: {
            min: 42697,
            max: 46892,
          },
          4500000: {
            min: 47317,
            max: 51952,
          },
          5000000: {
            min: 51937,
            max: 57012,
          },
          7500000: {
            min: 75037,
            max: 82312,
          },
          10000000: {
            min: 98137,
            max: 107612,
          },
          10225838: {
            min: 100223,
            max: 109897,
          },
        },
        III: {
          51129: {
            min: 3037,
            max: 3431,
          },
          100000: {
            min: 4327,
            max: 4829,
          },
          150000: {
            min: 5542,
            max: 6153,
          },
          200000: {
            min: 6547,
            max: 7217,
          },
          250000: {
            min: 7437,
            max: 8212,
          },
          300000: {
            min: 8219,
            max: 9055,
          },
          350000: {
            min: 9037,
            max: 9929,
          },
          400000: {
            min: 9815,
            max: 10809,
          },
          450000: {
            min: 10630,
            max: 11644,
          },
          500000: {
            min: 11413,
            max: 12513,
          },
          750000: {
            min: 14002,
            max: 15336,
          },
          1000000: {
            min: 16532,
            max: 18086,
          },
          1500000: {
            min: 21592,
            max: 23586,
          },
          2000000: {
            min: 26652,
            max: 29086,
          },
          2500000: {
            min: 31712,
            max: 34586,
          },
          3000000: {
            min: 36772,
            max: 40086,
          },
          3500000: {
            min: 41832,
            max: 45586,
          },
          4000000: {
            min: 46892,
            max: 51086,
          },
          4500000: {
            min: 51952,
            max: 56586,
          },
          5000000: {
            min: 57012,
            max: 62086,
          },
          7500000: {
            min: 82312,
            max: 89586,
          },
          10000000: {
            min: 107612,
            max: 117086,
          },
          10225838: {
            min: 109897,
            max: 119571,
          },
        },
        IV: {
          51129: {
            min: 3431,
            max: 3825,
          },
          100000: {
            min: 4829,
            max: 5330,
          },
          150000: {
            min: 6153,
            max: 6765,
          },
          200000: {
            min: 7217,
            max: 7939,
          },
          250000: {
            min: 8212,
            max: 8994,
          },
          300000: {
            min: 9055,
            max: 9892,
          },
          350000: {
            min: 9929,
            max: 10867,
          },
          400000: {
            min: 10809,
            max: 11765,
          },
          450000: {
            min: 11644,
            max: 12690,
          },
          500000: {
            min: 12513,
            max: 13625,
          },
          750000: {
            min: 15336,
            max: 16672,
          },
          1000000: {
            min: 18086,
            max: 19642,
          },
          1500000: {
            min: 23586,
            max: 25582,
          },
          2000000: {
            min: 29086,
            max: 31522,
          },
          2500000: {
            min: 34586,
            max: 37462,
          },
          3000000: {
            min: 40086,
            max: 43402,
          },
          3500000: {
            min: 45586,
            max: 49342,
          },
          4000000: {
            min: 51086,
            max: 55282,
          },
          4500000: {
            min: 56586,
            max: 61222,
          },
          5000000: {
            min: 62086,
            max: 67162,
          },
          7500000: {
            min: 89586,
            max: 96862,
          },
          10000000: {
            min: 117086,
            max: 126562,
          },
          10225838: {
            min: 119571,
            max: 129245,
          },
        },
        V: {
          51129: {
            min: 3825,
            max: 4219,
          },
          100000: {
            min: 5330,
            max: 5831,
          },
          150000: {
            min: 6765,
            max: 7376,
          },
          200000: {
            min: 7939,
            max: 8609,
          },
          250000: {
            min: 8994,
            max: 9768,
          },
          300000: {
            min: 9892,
            max: 10728,
          },
          350000: {
            min: 10867,
            max: 11758,
          },
          400000: {
            min: 11765,
            max: 12757,
          },
          450000: {
            min: 12690,
            max: 13747,
          },
          500000: {
            min: 13625,
            max: 14737,
          },
          750000: {
            min: 16672,
            max: 18006,
          },
          1000000: {
            min: 19642,
            max: 21196,
          },
          1500000: {
            min: 25582,
            max: 27576,
          },
          2000000: {
            min: 31522,
            max: 33956,
          },
          2500000: {
            min: 37462,
            max: 40336,
          },
          3000000: {
            min: 43402,
            max: 46716,
          },
          3500000: {
            min: 49342,
            max: 53096,
          },
          4000000: {
            min: 55282,
            max: 59476,
          },
          4500000: {
            min: 61222,
            max: 65856,
          },
          5000000: {
            min: 67162,
            max: 72236,
          },
          7500000: {
            min: 96862,
            max: 104136,
          },
          10000000: {
            min: 126562,
            max: 136036,
          },
          10225838: {
            min: 129245,
            max: 138918,
          },
        },
      },
      phases: [
        {
          title: 'Baugeometrische Beratung',
          maxPercent: '2',
        },
        {
          title: 'Absteckung für die Bauausführung',
          maxPercent: '14',
        },
        {
          title: 'Bauausführungsvermessung',
          maxPercent: '66',
        },
        {
          title: 'Vermessungstechnische Überwachung der Bauausführung',
          maxPercent: '18',
        },
      ],
    },
  ],
};
